import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
};

export type AggregatedAviatorAnalytics = {
  __typename?: 'AggregatedAviatorAnalytics';
  records: Array<AggregatedRoundTransaction>;
  totalRoundByDate: Scalars['JSON']['output'];
};

export type AggregatedRoundTransaction = {
  __typename?: 'AggregatedRoundTransaction';
  averageBetAmount?: Maybe<Scalars['Float']['output']>;
  averageWinAmount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  largestBetAmount?: Maybe<Scalars['Float']['output']>;
  largestWin?: Maybe<Scalars['Float']['output']>;
  lowestBetAmount?: Maybe<Scalars['Float']['output']>;
  lowestWin?: Maybe<Scalars['Float']['output']>;
  numberOfRounds?: Maybe<Scalars['Float']['output']>;
  numberOfUsers?: Maybe<Scalars['Int']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  totalBetAmount?: Maybe<Scalars['Float']['output']>;
  totalLosingBets?: Maybe<Scalars['Int']['output']>;
  totalWinningBets?: Maybe<Scalars['Int']['output']>;
  totalWonAmount?: Maybe<Scalars['Float']['output']>;
};

export type AssignDefaultConfigArgs = {
  configIds: Array<Scalars['String']['input']>;
  providerId: Scalars['String']['input'];
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export enum BackOfficePermissionsEnum {
  CanAddLanguage = 'CAN_ADD_LANGUAGE',
  CanAddTranslationKey = 'CAN_ADD_TRANSLATION_KEY',
  CanBlockUnblockUsers = 'CAN_BLOCK_UNBLOCK_USERS',
  CanCancelRaindropCampaign = 'CAN_CANCEL_RAINDROP_CAMPAIGN',
  CanDeleteBackofficeUsers = 'CAN_DELETE_BACKOFFICE_USERS',
  CanDeleteUsers = 'CAN_DELETE_USERS',
  CanEditUsers = 'CAN_EDIT_USERS',
  CanExportTransactions = 'CAN_EXPORT_TRANSACTIONS',
  CanExportTranslations = 'CAN_EXPORT_TRANSLATIONS',
  CanImportTranslations = 'CAN_IMPORT_TRANSLATIONS',
  CanManageAviatorRounds = 'CAN_MANAGE_AVIATOR_ROUNDS',
  CanManageAviatorTransactions = 'CAN_MANAGE_AVIATOR_TRANSACTIONS',
  CanManageBackofficePermissions = 'CAN_MANAGE_BACKOFFICE_PERMISSIONS',
  CanManageBackofficeRoles = 'CAN_MANAGE_BACKOFFICE_ROLES',
  CanManageBackofficeUsers = 'CAN_MANAGE_BACKOFFICE_USERS',
  CanManageFreebets = 'CAN_MANAGE_FREEBETS',
  CanManageFreebetsCampaigns = 'CAN_MANAGE_FREEBETS_CAMPAIGNS',
  CanManageGlobalRoles = 'CAN_MANAGE_GLOBAL_ROLES',
  CanManageLocalizations = 'CAN_MANAGE_LOCALIZATIONS',
  CanManagePermissions = 'CAN_MANAGE_PERMISSIONS',
  CanManageProviders = 'CAN_MANAGE_PROVIDERS',
  CanManageProviderConfigs = 'CAN_MANAGE_PROVIDER_CONFIGS',
  CanManageRaindropCampaigns = 'CAN_MANAGE_RAINDROP_CAMPAIGNS',
  CanManageRoundConfigs = 'CAN_MANAGE_ROUND_CONFIGS',
  CanRetryFailedJobs = 'CAN_RETRY_FAILED_JOBS',
  CanRevokeFreebetsCampaigns = 'CAN_REVOKE_FREEBETS_CAMPAIGNS',
  CanRunTests = 'CAN_RUN_TESTS',
  CanViewAviatorAnalytics = 'CAN_VIEW_AVIATOR_ANALYTICS',
  CanViewAviatorRounds = 'CAN_VIEW_AVIATOR_ROUNDS',
  CanViewAviatorRoundTransactions = 'CAN_VIEW_AVIATOR_ROUND_TRANSACTIONS',
  CanViewBackofficePermissions = 'CAN_VIEW_BACKOFFICE_PERMISSIONS',
  CanViewBackofficeRoles = 'CAN_VIEW_BACKOFFICE_ROLES',
  CanViewBackofficeTasks = 'CAN_VIEW_BACKOFFICE_TASKS',
  CanViewBackofficeUsers = 'CAN_VIEW_BACKOFFICE_USERS',
  CanViewFailedSendCreditTransactions = 'CAN_VIEW_FAILED_SEND_CREDIT_TRANSACTIONS',
  CanViewFreebets = 'CAN_VIEW_FREEBETS',
  CanViewFreebetsCampaigns = 'CAN_VIEW_FREEBETS_CAMPAIGNS',
  CanViewFreebetsUsage = 'CAN_VIEW_FREEBETS_USAGE',
  CanViewFreebetsUsageLogs = 'CAN_VIEW_FREEBETS_USAGE_LOGS',
  CanViewLocalizations = 'CAN_VIEW_LOCALIZATIONS',
  CanViewOngoingRound = 'CAN_VIEW_ONGOING_ROUND',
  CanViewProviders = 'CAN_VIEW_PROVIDERS',
  CanViewProviderConfigs = 'CAN_VIEW_PROVIDER_CONFIGS',
  CanViewProviderIgnoredRequests = 'CAN_VIEW_PROVIDER_IGNORED_REQUESTS',
  CanViewProviderPublicKey = 'CAN_VIEW_PROVIDER_PUBLIC_KEY',
  CanViewProviderTransactions = 'CAN_VIEW_PROVIDER_TRANSACTIONS',
  CanViewRaindropCampaigns = 'CAN_VIEW_RAINDROP_CAMPAIGNS',
  CanViewRoundConfigs = 'CAN_VIEW_ROUND_CONFIGS',
  CanViewScheduledSendCreditTasks = 'CAN_VIEW_SCHEDULED_SEND_CREDIT_TASKS',
  CanViewTransactionExports = 'CAN_VIEW_TRANSACTION_EXPORTS',
}

export type BackOfficeSession = {
  __typename?: 'BackOfficeSession';
  provider?: Maybe<Provider>;
  session: Session;
};

export type CancelRaindropCampaignType = {
  __typename?: 'CancelRaindropCampaignType';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum ClaimLimitPeriod {
  FiveMinutes = 'FIVE_MINUTES',
  FiveSeconds = 'FIVE_SECONDS',
  OneMinute = 'ONE_MINUTE',
  RainDuration = 'RAIN_DURATION',
  TenSeconds = 'TEN_SECONDS',
  ThirtySeconds = 'THIRTY_SECONDS',
}

export type CreateFreeBetCampaignInput = {
  description: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  providerId: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type CreateProviderArgs = {
  apiUrl: Scalars['String']['input'];
  filterExternalProviderBets: Scalars['Boolean']['input'];
  enableInactivityScreen?: Scalars['Boolean']['input'];
  integrationType?: InputMaybe<ProviderIntegrationType>;
  isInternal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notifyOnLastFreebet?: InputMaybe<Scalars['Boolean']['input']>;
  raindropType?: RaindropTypeEnum;
  refundOnCreditFail: Scalars['Boolean']['input'];
  retryScheduledSendCredit: Scalars['Boolean']['input'];
  status: ProviderStatus;
  syncFreebet?: InputMaybe<Scalars['Boolean']['input']>;
  syncRaindrop?: InputMaybe<Scalars['Boolean']['input']>;
  syncRoundEnd: Scalars['Boolean']['input'];
};

export type CreateProviderConfigArgs = {
  betSuggestions: Array<Scalars['Float']['input']>;
  currency: Scalars['String']['input'];
  defaultAutoCashout: Scalars['Float']['input'];
  defaultBet: Scalars['Float']['input'];
  isRoundable: Scalars['Boolean']['input'];
  maxAutoCashout: Scalars['Float']['input'];
  maxBet: Scalars['Float']['input'];
  maxWin: Scalars['Float']['input'];
  minAutoCashout: Scalars['Float']['input'];
  minBet: Scalars['Float']['input'];
  providerId: Scalars['String']['input'];
};

export type CreateRaindropCampaignInput = {
  casinoId?: InputMaybe<Scalars['String']['input']>;
  claimDeadlineMinutes: Scalars['Int']['input'];
  claimLimitNumber?: InputMaybe<Scalars['Int']['input']>;
  claimLimitPeriod?: InputMaybe<ClaimLimitPeriod>;
  currency: Scalars['String']['input'];
  dayBudget?: InputMaybe<Scalars['Float']['input']>;
  distributionFrom: Scalars['String']['input'];
  distributionTo: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  freebetValidityDate: Scalars['DateTime']['input'];
  freebetValue: Scalars['Float']['input'];
  freebetsPerRain: Scalars['Int']['input'];
  gameId?: Scalars['Int']['input'];
  minMultiplier: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  playerMinBalance?: InputMaybe<Scalars['Float']['input']>;
  playerMinWager?: InputMaybe<Scalars['Float']['input']>;
  providerId: Scalars['String']['input'];
  rainsPerDay: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  status?: InputMaybe<RaindropCampaignStatus>;
  timezone: Scalars['String']['input'];
  totalBudget?: InputMaybe<Scalars['Float']['input']>;
  wagerPeriod?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateRaindropCampaignType = {
  __typename?: 'CreateRaindropCampaignType';
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ErrorsType = {
  __typename?: 'ErrorsType';
  err: Scalars['String']['output'];
};

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  /** Amount used to calculate the exchange rate */
  amount: Scalars['Float']['output'];
  /** Date-time when the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** The date associated with this exchange rate */
  date: Scalars['DateTime']['output'];
  /** Source currency code */
  from: Scalars['String']['output'];
  /** MongoDB ObjectId as a string */
  id: Scalars['ID']['output'];
  /** Exchange rate between source and target currencies */
  rate: Scalars['Float']['output'];
  /** Exchange rate between target and source currencies (reversed) */
  rateReversed: Scalars['Float']['output'];
  /** Link to Terms of Use or legal documentation */
  terms: Scalars['String']['output'];
  /** Target currency code */
  to: Scalars['String']['output'];
  /** Date-time when the document was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Maximum number of calls allowed per minute */
  xRateLimit: Scalars['Float']['output'];
  /** Number of calls remaining in the current minute */
  xRateLimitRemaining: Scalars['Float']['output'];
  /** UNIX timestamp when the per-minute rate limit resets */
  xRateLimitReset: Scalars['Float']['output'];
  /** Maximum number of requests allowed per day */
  xRateRequestLimit: Scalars['Float']['output'];
  /** Number of requests remaining for the current day */
  xRateRequestRemaining: Scalars['Float']['output'];
  /** UNIX timestamp when the daily request limit resets */
  xRateRequestReset: Scalars['Float']['output'];
  /** Request ID for this API call */
  xRequestId: Scalars['String']['output'];
};

export type FailedFinalizeRoundTask = {
  __typename?: 'FailedFinalizeRoundTask';
  failedReason?: Maybe<Scalars['String']['output']>;
  finishedOn?: Maybe<Scalars['Float']['output']>;
  jobId: Scalars['String']['output'];
  processedOn?: Maybe<Scalars['Float']['output']>;
  roundId: Scalars['String']['output'];
};

export type FailedRoundSyncTask = {
  __typename?: 'FailedRoundSyncTask';
  attempts: Scalars['Int']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  failedReason?: Maybe<Scalars['String']['output']>;
  finishedOn?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  processedOn?: Maybe<Scalars['Float']['output']>;
};

export type FailedSendCreditTask = {
  __typename?: 'FailedSendCreditTask';
  attempts: Scalars['Int']['output'];
  data?: Maybe<FailedSendCreditTaskData>;
  failedReason?: Maybe<Scalars['String']['output']>;
  finishedOn?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  processedOn?: Maybe<Scalars['Float']['output']>;
};

export type FailedSendCreditTaskData = {
  __typename?: 'FailedSendCreditTaskData';
  amount: Scalars['Int']['output'];
  apiUrl: Scalars['String']['output'];
  betId: Scalars['String']['output'];
  category: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  gameId: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  multiplier: Scalars['Float']['output'];
  operation: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  roundId: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export enum FreeBetAccessStatusEnum {
  Active = 'ACTIVE',
  Revoked = 'REVOKED',
}

export type FreeBetsCampaign = {
  __typename?: 'FreeBetsCampaign';
  _id: Scalars['String']['output'];
  campaignUniqueId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  providerId: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FreeBetsUsage = {
  __typename?: 'FreeBetsUsage';
  _id: Scalars['String']['output'];
  activeDate: Scalars['DateTime']['output'];
  betNominal: Scalars['Float']['output'];
  campaignId: Scalars['String']['output'];
  count: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  minMultiplier: Scalars['Float']['output'];
  playerId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalWin: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usage: Scalars['Float']['output'];
  validityDate: Scalars['DateTime']['output'];
};

export type FreeBetsUsageLog = {
  __typename?: 'FreeBetsUsageLog';
  _id: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
  clearedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  gameId: Scalars['Float']['output'];
  playerId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  roundId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usageId: Scalars['String']['output'];
  win: Scalars['Float']['output'];
};

export type InputAssignRoleIds = {
  roleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type InputAssignRolePermissions = {
  permissions: Array<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
};

export type InputCreateLocalization = {
  componentCopyCopied?: InputMaybe<Scalars['String']['input']>;
  componentErrorConnectFailedDescription?: InputMaybe<Scalars['String']['input']>;
  componentErrorConnectFailedHome?: InputMaybe<Scalars['String']['input']>;
  componentErrorConnectFailedTitle?: InputMaybe<Scalars['String']['input']>;
  componentErrorDisconnectDescription?: InputMaybe<Scalars['String']['input']>;
  componentErrorDisconnectTitle?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalAuthenticationDescription?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalAuthenticationTitle?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalDefaultDescription?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalDefaultTitle?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalGeneralDescription?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalGeneralTitle?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalHome?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalSwitchedDescription?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalSwitchedTitle?: InputMaybe<Scalars['String']['input']>;
  componentInputApply?: InputMaybe<Scalars['String']['input']>;
  gameAvatarSave?: InputMaybe<Scalars['String']['input']>;
  gameAvatarTitle?: InputMaybe<Scalars['String']['input']>;
  gameBetAutoBet?: InputMaybe<Scalars['String']['input']>;
  gameBetAutoCashOut?: InputMaybe<Scalars['String']['input']>;
  gameBetBet?: InputMaybe<Scalars['String']['input']>;
  gameBetCancel?: InputMaybe<Scalars['String']['input']>;
  gameBetCashOut?: InputMaybe<Scalars['String']['input']>;
  gameBetErrorBalance?: InputMaybe<Scalars['String']['input']>;
  gameBetErrorFreeBet?: InputMaybe<Scalars['String']['input']>;
  gameBetErrorGlobal?: InputMaybe<Scalars['String']['input']>;
  gameBetFreeBet?: InputMaybe<Scalars['String']['input']>;
  gameBetFreeBetCheck?: InputMaybe<Scalars['String']['input']>;
  gameBetWaiting?: InputMaybe<Scalars['String']['input']>;
  gameDisplayFlew?: InputMaybe<Scalars['String']['input']>;
  gameDisplayLoading?: InputMaybe<Scalars['String']['input']>;
  gameFooterProvablyFair?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsHistoryDate?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsHistoryGranted?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsHistoryMinCashout?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTabActive?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTabHistory?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTableBet?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTableCashout?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTableCount?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTableEmpty?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTitle?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsClientDescription?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsClientLabel?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsCombinedDecimal?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsCombinedDescription?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsCombinedHex?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsCombinedLabel?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsCombinedResult?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsDate?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsPlayerSeed?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsPlayerTitle?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsProvablyFair?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsServerDescription?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsServerLabel?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsTitle?: InputMaybe<Scalars['String']['input']>;
  gameHistoryTitle?: InputMaybe<Scalars['String']['input']>;
  gameId: Scalars['Int']['input'];
  gameLimitsMax?: InputMaybe<Scalars['String']['input']>;
  gameLimitsMin?: InputMaybe<Scalars['String']['input']>;
  gameLimitsTitle?: InputMaybe<Scalars['String']['input']>;
  gameLimitsWin?: InputMaybe<Scalars['String']['input']>;
  gameMenuAnimation?: InputMaybe<Scalars['String']['input']>;
  gameMenuFreeBets?: InputMaybe<Scalars['String']['input']>;
  gameMenuHome?: InputMaybe<Scalars['String']['input']>;
  gameMenuLimits?: InputMaybe<Scalars['String']['input']>;
  gameMenuMusic?: InputMaybe<Scalars['String']['input']>;
  gameMenuMyBets?: InputMaybe<Scalars['String']['input']>;
  gameMenuRules?: InputMaybe<Scalars['String']['input']>;
  gameMenuSound?: InputMaybe<Scalars['String']['input']>;
  gameMyBetsTableEmpty?: InputMaybe<Scalars['String']['input']>;
  gameMyBetsTitle?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsMyBet?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsMyDate?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsMyEmpty?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsMyWin?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundCurrentPrevious?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundCurrentTotal?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundPreviousPrevious?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundPreviousTotal?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundTableBet?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundTableEmpty?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundTablePlayer?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundTableWin?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsTabCurrent?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsTabMy?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairHowLongDescription?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairHowLongTitle?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairHowShortDescription?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairHowShortTitle?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairHowTitle?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairReliabilityDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  gameProvablyFairReliabilityTitle?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairTitle?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairWhatDescription?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairWhatTitle?: InputMaybe<Scalars['String']['input']>;
  gameRulesAccordion0Description?: InputMaybe<Array<Scalars['String']['input']>>;
  gameRulesAccordion0Title?: InputMaybe<Scalars['String']['input']>;
  gameRulesAccordion1Description?: InputMaybe<Array<Scalars['String']['input']>>;
  gameRulesAccordion1Title?: InputMaybe<Scalars['String']['input']>;
  gameRulesAccordion2Description?: InputMaybe<Array<Scalars['String']['input']>>;
  gameRulesAccordion2Title?: InputMaybe<Scalars['String']['input']>;
  gameRulesAccordion3Description?: InputMaybe<Array<Scalars['String']['input']>>;
  gameRulesAccordion3Title?: InputMaybe<Scalars['String']['input']>;
  gameRulesAccordion4Description?: InputMaybe<Array<Scalars['String']['input']>>;
  gameRulesAccordion4Title?: InputMaybe<Scalars['String']['input']>;
  gameRulesAdditionalTitle?: InputMaybe<Scalars['String']['input']>;
  gameRulesHowDescription?: InputMaybe<Scalars['String']['input']>;
  gameRulesHowTitle?: InputMaybe<Scalars['String']['input']>;
  gameRulesSlider1?: InputMaybe<Scalars['String']['input']>;
  gameRulesSlider2?: InputMaybe<Scalars['String']['input']>;
  gameRulesTitle?: InputMaybe<Scalars['String']['input']>;
  gameRulesVideoDescription?: InputMaybe<Scalars['String']['input']>;
  gameRulesVideoTitle?: InputMaybe<Scalars['String']['input']>;
  gameWinSnackbarLabel?: InputMaybe<Scalars['String']['input']>;
  gameWinSnackbarWin?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
};

export type InputCreateRole = {
  description: Scalars['String']['input'];
  isEditable: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  permissions: Array<BackOfficePermissionsEnum>;
};

export type InputCreateUser = {
  allowedRoleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  email: Scalars['String']['input'];
  isProviderUsersAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerRgs?: InputMaybe<Array<InputProviderRgs>>;
  roleIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputDeleteRole = {
  roleId: Scalars['String']['input'];
};

export type InputDeleteUserRole = {
  roleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type InputFilterExchangeRates = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterFreeBetUsageLogs = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxWin?: InputMaybe<Scalars['Float']['input']>;
  minWin?: InputMaybe<Scalars['Float']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  roundId?: InputMaybe<Scalars['String']['input']>;
  usageId?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterFreeBetsCampagins = {
  campaignUniqueId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<FreeBetAccessStatusEnum>;
  validCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputFilterFreeBetsUsage = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  freebetUsageLogId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxBetNominal?: InputMaybe<Scalars['Float']['input']>;
  maxCount?: InputMaybe<Scalars['Float']['input']>;
  maxMultiplier?: InputMaybe<Scalars['Float']['input']>;
  maxTotalWin?: InputMaybe<Scalars['Float']['input']>;
  maxUsage?: InputMaybe<Scalars['Float']['input']>;
  minBetNominal?: InputMaybe<Scalars['Float']['input']>;
  minCount?: InputMaybe<Scalars['Float']['input']>;
  minMultiplier?: InputMaybe<Scalars['Float']['input']>;
  minTotalWin?: InputMaybe<Scalars['Float']['input']>;
  minUsage?: InputMaybe<Scalars['Float']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  validityEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  validityStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InputFilterIgnoredRequests = {
  createdAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStart?: InputMaybe<Scalars['DateTime']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  roundId?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterPlayerIds = {
  roundId?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterProviderFailedTransactions = {
  _id?: InputMaybe<Scalars['String']['input']>;
  awardId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['Float']['input']>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  multiplier?: InputMaybe<Scalars['Float']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  previousTransactionId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  roundId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterProviderTransaction = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  maxBalance?: InputMaybe<Scalars['Float']['input']>;
  maxMultiplier?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  minBalance?: InputMaybe<Scalars['Float']['input']>;
  minMultiplier?: InputMaybe<Scalars['Float']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  roundId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterRoundTransaction = {
  clientHash?: InputMaybe<Scalars['String']['input']>;
  createdEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  freebetUsageLogId?: InputMaybe<Scalars['String']['input']>;
  freebetUsageRecordId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isAutoCashout?: InputMaybe<Scalars['Boolean']['input']>;
  isFreebet?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  maxBetAmount?: InputMaybe<Scalars['Float']['input']>;
  maxBetNominal?: InputMaybe<Scalars['Float']['input']>;
  maxCashoutDate?: InputMaybe<Scalars['DateTime']['input']>;
  maxMaxMultiplier?: InputMaybe<Scalars['Float']['input']>;
  maxMultiplier?: InputMaybe<Scalars['Float']['input']>;
  maxWin?: InputMaybe<Scalars['Float']['input']>;
  minBetAmount?: InputMaybe<Scalars['Float']['input']>;
  minBetNominal?: InputMaybe<Scalars['Float']['input']>;
  minCashoutDate?: InputMaybe<Scalars['DateTime']['input']>;
  minMaxMultiplier?: InputMaybe<Scalars['Float']['input']>;
  minMultiplier?: InputMaybe<Scalars['Float']['input']>;
  minWin?: InputMaybe<Scalars['Float']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  playerRoundBetId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  roundHash?: InputMaybe<Scalars['String']['input']>;
  roundId?: InputMaybe<Scalars['String']['input']>;
  serverHash?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterRounds = {
  clientHash?: InputMaybe<Scalars['String']['input']>;
  configId?: InputMaybe<Scalars['String']['input']>;
  createdEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxMultiplierCrash?: InputMaybe<Scalars['Float']['input']>;
  minMultiplierCrash?: InputMaybe<Scalars['Float']['input']>;
  phase?: InputMaybe<Scalars['String']['input']>;
  previousRoundId?: InputMaybe<Scalars['String']['input']>;
  roundHash?: InputMaybe<Scalars['String']['input']>;
  serverHash?: InputMaybe<Scalars['String']['input']>;
};

export type InputProviderFilter = {
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<ProviderIntegrationType>;
  name?: InputMaybe<Scalars['String']['input']>;
  refundOnCreditFail?: InputMaybe<Scalars['Boolean']['input']>;
  retryScheduledSendCredit?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProviderStatus>;
  syncRoundEnd?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputProviderRgs = {
  providerIds: Array<Scalars['String']['input']>;
  rgsId: Rgs;
};

export type InputRemoveRolePermission = {
  permission: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};

export type InputUpdateLocalization = {
  language: Scalars['String']['input'];
  localizationKey: Scalars['String']['input'];
  localizationValue: Scalars['String']['input'];
};

export type InputUpdateRoundStatus = {
  configId: Scalars['String']['input'];
  status: RoundStatus;
};

export type InputUpdateUser = {
  allowedRoleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  isProviderUsersAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerRgs?: InputMaybe<Array<InputProviderRgs>>;
  roleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};

export type Localization = {
  __typename?: 'Localization';
  _id: Scalars['String']['output'];
  gameId: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  translations: Scalars['String']['output'];
};

export type LocalizationObjectType = {
  __typename?: 'LocalizationObjectType';
  languages?: Maybe<Array<Scalars['String']['output']>>;
  translations: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addLocalizationKey: Scalars['Boolean']['output'];
  addNewLanguage?: Maybe<Scalars['Boolean']['output']>;
  addPermission: Scalars['Float']['output'];
  assignDefaultConfigs: Scalars['Float']['output'];
  assignRolePermissions: Scalars['Boolean']['output'];
  assignUserRolesIds: Scalars['Boolean']['output'];
  cancelRaindropCampaign: CancelRaindropCampaignType;
  createFreeBetCampaign: FreeBetsCampaign;
  createLocalization: Localization;
  createLocalizationDefault: Localization;
  createProvider: Provider;
  createProviderConfig: ProviderConfig;
  createRaindropCampaign: CreateRaindropCampaignType;
  createRole: Role;
  createUser: User;
  deleteProviderConfig: Scalars['Int']['output'];
  deleteRole: Scalars['Int']['output'];
  deleteUser: Scalars['Int']['output'];
  deleteUserRole: Scalars['Int']['output'];
  generateDefaultProviderConfigs: Scalars['Boolean']['output'];
  refreshToken: AuthPayload;
  removeRolePermission: Scalars['Int']['output'];
  retryFailedJob: Scalars['Boolean']['output'];
  revokeSpecificFreeBet: Scalars['Boolean']['output'];
  signIn: AuthPayload;
  testProvider: TestProviderResponseObjectType;
  updateFreeBetCampaign: Scalars['Boolean']['output'];
  updateLocalization: Scalars['Boolean']['output'];
  updateProvider: Scalars['Int']['output'];
  updateProviderConfig: Scalars['Int']['output'];
  updateRoundStatus: Scalars['Boolean']['output'];
  updateUser: User;
};

export type MutationAddLocalizationKeyArgs = {
  input: InputUpdateLocalization;
};

export type MutationAddNewLanguageArgs = {
  newLanguage: Scalars['String']['input'];
};

export type MutationAddPermissionArgs = {
  permission: Scalars['String']['input'];
};

export type MutationAssignDefaultConfigsArgs = {
  input: AssignDefaultConfigArgs;
};

export type MutationAssignRolePermissionsArgs = {
  input: InputAssignRolePermissions;
};

export type MutationAssignUserRolesIdsArgs = {
  input: InputAssignRoleIds;
};

export type MutationCancelRaindropCampaignArgs = {
  campaignId: Scalars['String']['input'];
};

export type MutationCreateFreeBetCampaignArgs = {
  input: CreateFreeBetCampaignInput;
};

export type MutationCreateLocalizationArgs = {
  input: InputCreateLocalization;
};

export type MutationCreateLocalizationDefaultArgs = {
  gameId: Scalars['Float']['input'];
  language: Scalars['String']['input'];
};

export type MutationCreateProviderArgs = {
  input: CreateProviderArgs;
};

export type MutationCreateProviderConfigArgs = {
  input: CreateProviderConfigArgs;
};

export type MutationCreateRaindropCampaignArgs = {
  input: CreateRaindropCampaignInput;
};

export type MutationCreateRoleArgs = {
  input: InputCreateRole;
};

export type MutationCreateUserArgs = {
  input: InputCreateUser;
};

export type MutationDeleteProviderConfigArgs = {
  configId: Scalars['String']['input'];
};

export type MutationDeleteRoleArgs = {
  input: InputDeleteRole;
};

export type MutationDeleteUserArgs = {
  userId: Scalars['String']['input'];
};

export type MutationDeleteUserRoleArgs = {
  input: InputDeleteUserRole;
};

export type MutationGenerateDefaultProviderConfigsArgs = {
  providerId: Scalars['String']['input'];
};

export type MutationRefreshTokenArgs = {
  token: Scalars['String']['input'];
};

export type MutationRemoveRolePermissionArgs = {
  input: InputRemoveRolePermission;
};

export type MutationRetryFailedJobArgs = {
  jobId: Scalars['String']['input'];
};

export type MutationRevokeSpecificFreeBetArgs = {
  input: RevokeCampaignFreeBetInput;
};

export type MutationSignInArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationTestProviderArgs = {
  testProviderInput: TestProvidersInput;
};

export type MutationUpdateFreeBetCampaignArgs = {
  input: UpdateFreeBetCampaignInput;
};

export type MutationUpdateLocalizationArgs = {
  input: InputUpdateLocalization;
};

export type MutationUpdateProviderArgs = {
  input: UpdateProviderArgs;
  providerId: Scalars['String']['input'];
};

export type MutationUpdateProviderConfigArgs = {
  configId: Scalars['String']['input'];
  input: UpdateProviderConfigArgs;
};

export type MutationUpdateRoundStatusArgs = {
  input: InputUpdateRoundStatus;
};

export type MutationUpdateUserArgs = {
  input: InputUpdateUser;
};

export type OngoingRound = {
  __typename?: 'OngoingRound';
  phase: Scalars['String']['output'];
  roundId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PaginatedFailedTransactions = {
  __typename?: 'PaginatedFailedTransactions';
  docs: Array<ProviderFailedSendCreditTransaction>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedFreeBets = {
  __typename?: 'PaginatedFreeBets';
  docs: Array<FreeBetsUsage>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedFreeBetsCampaigns = {
  __typename?: 'PaginatedFreeBetsCampaigns';
  docs: Array<FreeBetsCampaign>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedFreeBetsUsageLogs = {
  __typename?: 'PaginatedFreeBetsUsageLogs';
  docs: Array<FreeBetsUsageLog>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedProviderIgnoredRequests = {
  __typename?: 'PaginatedProviderIgnoredRequests';
  docs: Array<ProviderIgnoredRequests>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedProviderPlayers = {
  __typename?: 'PaginatedProviderPlayers';
  docs: Array<RoundPlayer>;
};

export type PaginatedProviderTransactions = {
  __typename?: 'PaginatedProviderTransactions';
  docs: Array<ProviderTransaction>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedRaindropCampaign = {
  __typename?: 'PaginatedRaindropCampaign';
  docs: Array<RaindropCampaignType>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedRounds = {
  __typename?: 'PaginatedRounds';
  docs: Array<Round>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedTransactions = {
  __typename?: 'PaginatedTransactions';
  docs: Array<RoundTransaction>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginationInput = {
  limit?: Scalars['Float']['input'];
  page?: Scalars['Float']['input'];
};

export type Provider = {
  __typename?: 'Provider';
  apiUrl: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  enableInactivityScreen?: Maybe<Scalars['Boolean']['output']>;
  filterExternalProviderBets?: Maybe<Scalars['Boolean']['output']>;
  homePageUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  integrationType?: Maybe<ProviderIntegrationType>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  notifyOnLastFreebet?: Maybe<Scalars['Boolean']['output']>;
  passPhrase: Scalars['String']['output'];
  privateKey: Scalars['String']['output'];
  publicKey: Scalars['String']['output'];
  raindropType?: Maybe<RaindropTypeEnum>;
  refundOnCreditFail?: Maybe<Scalars['Boolean']['output']>;
  retryScheduledSendCredit?: Maybe<Scalars['Boolean']['output']>;
  rgsId?: Maybe<Rgs>;
  status?: Maybe<ProviderStatus>;
  syncFreebet?: Maybe<Scalars['Boolean']['output']>;
  syncRaindrop?: Maybe<Scalars['Boolean']['output']>;
  syncRoundEnd?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProviderConfig = {
  __typename?: 'ProviderConfig';
  betSuggestions: Array<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  defaultAutoCashout?: Maybe<Scalars['Float']['output']>;
  defaultBet: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isRoundable: Scalars['Boolean']['output'];
  maxAutoCashout?: Maybe<Scalars['Float']['output']>;
  maxBet: Scalars['Float']['output'];
  maxWin: Scalars['Float']['output'];
  minAutoCashout?: Maybe<Scalars['Float']['output']>;
  minBet: Scalars['Float']['output'];
  providerId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProviderFailedSendCreditTransaction = {
  __typename?: 'ProviderFailedSendCreditTransaction';
  _id: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  awardId?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  gameId: Scalars['Float']['output'];
  isResolved?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  operation: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  previousTransactionId?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  roundId: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type ProviderIgnoredRequests = {
  __typename?: 'ProviderIgnoredRequests';
  betAmount?: Maybe<Scalars['String']['output']>;
  betId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  operation: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  roundId: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
};

export enum ProviderIntegrationType {
  Direct = 'DIRECT',
  ReverseBgi = 'REVERSE_BGI',
  ReverseBgiEsp = 'REVERSE_BGI_ESP',
}

export type ProviderPlayer = {
  __typename?: 'ProviderPlayer';
  playerId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type ProviderRgs = {
  __typename?: 'ProviderRgs';
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  rgsId: Rgs;
};

export enum ProviderStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type ProviderTransaction = {
  __typename?: 'ProviderTransaction';
  _id: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  awardId?: Maybe<Scalars['String']['output']>;
  balance: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  gameId: Scalars['Float']['output'];
  language?: Maybe<Scalars['String']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  operation: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  roundId: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  aggregatedAviatorAnalytics: AggregatedAviatorAnalytics;
  aggregatedRoundTransactionsByProviderId: AggregatedRoundTransaction;
  aggregatedRoundTransactionsByRoundIdProviderId: Array<AggregatedRoundTransaction>;
  aviatorFailedFinalizeRoundTasks: Array<FailedFinalizeRoundTask>;
  aviatorFailedProviderSendCreditTransactions: PaginatedFailedTransactions;
  aviatorFailedRoundSyncTasks: Array<FailedRoundSyncTask>;
  aviatorFailedSendCreditTasks: Array<FailedSendCreditTask>;
  aviatorLiveRoundStatus: Scalars['String']['output'];
  aviatorRoundConfigs: Array<RoundConfig>;
  aviatorRoundPlayers: RoundPlayers;
  aviatorScheduledSendCreditTasks: Array<ScheduledSendCreditTask>;
  countRoundsAviator: Scalars['Int']['output'];
  defaultCurrencyConfigs: Array<ProviderConfig>;
  exchangeRates: Array<ExchangeRate>;
  exportLocalizations?: Maybe<Scalars['String']['output']>;
  freeBetCampaign?: Maybe<FreeBetsCampaign>;
  freeBetUsageLog?: Maybe<FreeBetsUsageLog>;
  freeBetsUsage?: Maybe<FreeBetsUsage>;
  localization?: Maybe<Localization>;
  localizations?: Maybe<LocalizationObjectType>;
  ongoingRound: OngoingRound;
  paginatedAviatorPlayerIdsRounds: PaginatedProviderPlayers;
  paginatedAviatorRoundTransactions: PaginatedTransactions;
  paginatedAviatorRounds: PaginatedRounds;
  paginatedFreeBets: PaginatedFreeBets;
  paginatedFreeBetsCampaigns: PaginatedFreeBetsCampaigns;
  paginatedFreeBetsUsageLogs: PaginatedFreeBetsUsageLogs;
  paginatedProviderIgnoredRequests: PaginatedProviderIgnoredRequests;
  paginatedProviderTransactions: PaginatedProviderTransactions;
  permissions: Array<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  providerConfigs: Array<ProviderConfig>;
  providerPublicKey?: Maybe<Scalars['String']['output']>;
  providerTransaction?: Maybe<ProviderTransaction>;
  providers: Array<Provider>;
  providersFromAllRGS: Array<ProviderRgs>;
  raindropCampaigns: PaginatedRaindropCampaign;
  retryConfigs: Array<RetryConfig>;
  role?: Maybe<Role>;
  roles: Array<Role>;
  session: BackOfficeSession;
  user?: Maybe<User>;
  users: Array<User>;
};

export type QueryAggregatedAviatorAnalyticsArgs = {
  end: Scalars['DateTime']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['DateTime']['input'];
};

export type QueryAggregatedRoundTransactionsByProviderIdArgs = {
  providerId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAggregatedRoundTransactionsByRoundIdProviderIdArgs = {
  providerId?: InputMaybe<Scalars['String']['input']>;
  roundId: Scalars['String']['input'];
};

export type QueryAviatorFailedProviderSendCreditTransactionsArgs = {
  filter?: InputMaybe<InputFilterProviderFailedTransactions>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryAviatorRoundPlayersArgs = {
  roundId: Scalars['String']['input'];
};

export type QueryCountRoundsAviatorArgs = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type QueryExchangeRatesArgs = {
  input: InputFilterExchangeRates;
};

export type QueryExportLocalizationsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryFreeBetCampaignArgs = {
  id: Scalars['String']['input'];
};

export type QueryFreeBetUsageLogArgs = {
  id: Scalars['String']['input'];
};

export type QueryFreeBetsUsageArgs = {
  id: Scalars['String']['input'];
};

export type QueryLocalizationArgs = {
  gameId: Scalars['Float']['input'];
  language: Scalars['String']['input'];
};

export type QueryLocalizationsArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryPaginatedAviatorPlayerIdsRoundsArgs = {
  filter?: InputMaybe<InputFilterPlayerIds>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryPaginatedAviatorRoundTransactionsArgs = {
  filter?: InputMaybe<InputFilterRoundTransaction>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
};

export type QueryPaginatedAviatorRoundsArgs = {
  filter?: InputMaybe<InputFilterRounds>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
};

export type QueryPaginatedFreeBetsArgs = {
  filter?: InputMaybe<InputFilterFreeBetsUsage>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPaginatedFreeBetsCampaignsArgs = {
  filter?: InputMaybe<InputFilterFreeBetsCampagins>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPaginatedFreeBetsUsageLogsArgs = {
  filter?: InputMaybe<InputFilterFreeBetUsageLogs>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
};

export type QueryPaginatedProviderIgnoredRequestsArgs = {
  filter?: InputMaybe<InputFilterIgnoredRequests>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
};

export type QueryPaginatedProviderTransactionsArgs = {
  filter?: InputMaybe<InputFilterProviderTransaction>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
};

export type QueryProviderArgs = {
  providerId: Scalars['String']['input'];
};

export type QueryProviderConfigsArgs = {
  id: Scalars['String']['input'];
};

export type QueryProviderPublicKeyArgs = {
  providerId: Scalars['String']['input'];
};

export type QueryProviderTransactionArgs = {
  id: Scalars['String']['input'];
};

export type QueryProvidersArgs = {
  filters?: InputMaybe<InputProviderFilter>;
};

export type QueryRaindropCampaignsArgs = {
  filter?: InputMaybe<RaindropCampaignFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryRoleArgs = {
  id: Scalars['String']['input'];
};

export type QueryUserArgs = {
  id: Scalars['String']['input'];
};

/** RGS identifiers */
export enum Rgs {
  Af = 'AF',
  Af1 = 'AF1',
  Af2 = 'AF2',
  Af3 = 'AF3',
  As = 'AS',
  As1 = 'AS1',
  Eu = 'EU',
  Eu2 = 'EU2',
  Sa = 'SA',
}

export type RaindropCampaignFilterInput = {
  casinoId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<RaindropCampaignStatus>;
};

export enum RaindropCampaignStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
}

export type RaindropCampaignType = {
  __typename?: 'RaindropCampaignType';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  casinoId?: Maybe<Scalars['String']['output']>;
  claimDeadlineMinutes: Scalars['Float']['output'];
  claimLimitNumber: Scalars['Float']['output'];
  claimLimitPeriod?: Maybe<ClaimLimitPeriod>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  dayBudget?: Maybe<Scalars['Float']['output']>;
  distributionFrom: Scalars['String']['output'];
  distributionTo: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  freebetCampaignId?: Maybe<Scalars['String']['output']>;
  freebetValidityDate: Scalars['DateTime']['output'];
  freebetValue: Scalars['Float']['output'];
  freebetsPerRain: Scalars['Float']['output'];
  gameId: Scalars['Int']['output'];
  id?: Maybe<Scalars['String']['output']>;
  minMultiplier: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  playerMinBalance?: Maybe<Scalars['Float']['output']>;
  playerMinWager?: Maybe<Scalars['Float']['output']>;
  providerId: Scalars['String']['output'];
  rainsPerDay: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  status: RaindropCampaignStatus;
  timezone: Scalars['String']['output'];
  totalBudget?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  wagerPeriod?: Maybe<Scalars['Float']['output']>;
};

/** Raindrop types */
export enum RaindropTypeEnum {
  RaindropMultiview = 'RAINDROP_MULTIVIEW',
  RaindropQueue = 'RAINDROP_QUEUE',
}

export type RetryConfig = {
  __typename?: 'RetryConfig';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  intervals: Array<Scalars['Float']['output']>;
  maxDuration: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RevokeCampaignFreeBetInput = {
  campaignId: Scalars['String']['input'];
  freeBetId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};

export type Role = {
  __typename?: 'Role';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
};

export type Round = {
  __typename?: 'Round';
  _id?: Maybe<Scalars['String']['output']>;
  clientHash?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['String']['output']>;
  multiplierCrash?: Maybe<Scalars['Float']['output']>;
  permutationOptions?: Maybe<Array<RoundOptionPermutationLog>>;
  playerIds?: Maybe<Array<Scalars['String']['output']>>;
  roundHash?: Maybe<Scalars['String']['output']>;
  serverHash?: Maybe<Scalars['String']['output']>;
};

export type RoundConfig = {
  __typename?: 'RoundConfig';
  _id?: Maybe<Scalars['String']['output']>;
  bettingTime: Scalars['Float']['output'];
  forcedCrashFrequency: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  margin: Scalars['Float']['output'];
  maxCrashPoint: Scalars['Float']['output'];
  probabilityWeights: Array<Scalars['Float']['output']>;
  waitingTime: Scalars['Float']['output'];
};

export type RoundOptionPermutationLog = {
  __typename?: 'RoundOptionPermutationLog';
  probabilityWeight: Scalars['Float']['output'];
  rawMultiplier: Scalars['Float']['output'];
  roundHash: Scalars['String']['output'];
};

export type RoundPlayer = {
  __typename?: 'RoundPlayer';
  playerId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type RoundPlayers = {
  __typename?: 'RoundPlayers';
  players: Array<RoundPlayer>;
  round: Round;
};

export enum RoundStatus {
  Paused = 'PAUSED',
  Running = 'RUNNING',
}

export type RoundTransaction = {
  __typename?: 'RoundTransaction';
  _id?: Maybe<Scalars['String']['output']>;
  betAmount: Scalars['Float']['output'];
  betNominal?: Maybe<Scalars['Float']['output']>;
  cashoutDate?: Maybe<Scalars['DateTime']['output']>;
  casinoId?: Maybe<Scalars['String']['output']>;
  clientHash?: Maybe<Scalars['String']['output']>;
  convertedWin?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  freebetUsageLogId?: Maybe<Scalars['String']['output']>;
  freebetUsageRecordId?: Maybe<Scalars['String']['output']>;
  gameId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isAutoCashout: Scalars['Boolean']['output'];
  isFreebet: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  maxMultiplier?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  playerId: Scalars['String']['output'];
  playerRoundBetId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  roundHash?: Maybe<Scalars['String']['output']>;
  roundId: Scalars['String']['output'];
  serverHash?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
  win?: Maybe<Scalars['Float']['output']>;
};

export type ScheduledSendCreditTask = {
  __typename?: 'ScheduledSendCreditTask';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<ScheduledSendCreditTaskData>;
  delayMs?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
};

export type ScheduledSendCreditTaskData = {
  __typename?: 'ScheduledSendCreditTaskData';
  amount: Scalars['Float']['output'];
  apiUrl: Scalars['String']['output'];
  betId: Scalars['String']['output'];
  category: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  gameId: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  multiplier?: Maybe<Scalars['Float']['output']>;
  operation: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  roundId: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type Session = {
  __typename?: 'Session';
  allowedRoleIds?: Maybe<Array<Scalars['String']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isProviderUsersAdmin?: Maybe<Scalars['Boolean']['output']>;
  isSuper?: Maybe<Scalars['Boolean']['output']>;
  permissions: Array<Scalars['String']['output']>;
  providerIds?: Maybe<Array<Scalars['String']['output']>>;
  rgsIds?: Maybe<Array<Rgs>>;
};

export type TestCheck = {
  __typename?: 'TestCheck';
  endpoint: Scalars['String']['output'];
  errors?: Maybe<Array<ErrorsType>>;
  testCase?: Maybe<Scalars['String']['output']>;
};

export type TestProviderResponseObjectType = {
  __typename?: 'TestProviderResponseObjectType';
  data?: Maybe<Array<TestCheck>>;
  errorsCount?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
};

export type TestProvidersInput = {
  /** transactionAmountNominal */
  amount: Scalars['Int']['input'];
  /** Currency Type: EUR | USD | GEL etc. */
  currency: Scalars['String']['input'];
  /** client url for example: http://localhost:3000?token=lyNpWc3xE1UDzPs25vNB%2BHYLODWpUTNEksSrCTK5Cgn2ZrE3u06SBEnBeaPEeaRYojsOMtbCbewokQSezGN5MEjSlkeJuMPvoBg1vMRqBUGUbkfJ7cd5m%2BCxcYEhgx8Ebjl8RbNIUt0aR%2FRZMaU988zshOGNd7WmCwNRJ8I0ma6ni4Kjhv3j8Q3%2FX%2Fvge1rsVzkSQ7KXaBbHMWZQ6Cxql8eQEueAAnjItfa0gvGgO3b4C0LYrgYGTq7L4jJ5B8an7WT6Pae8jUg%2FwlU8is4G0lXnanzreBemPWOWF0ZzcMxf6H%2Baw%2FNKOv6YTBseRYw7%2B83jsOBng0fQllSSPGTGLg%3D%3D&providerId=66ffba1337e994c3009ebf40&currency=GEL&language=en */
  url: Scalars['String']['input'];
};

export type UpdateFreeBetCampaignInput = {
  campaignId: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  providerId: Scalars['String']['input'];
};

export type UpdateProviderArgs = {
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  enableInactivityScreen?: InputMaybe<Scalars['Boolean']['input']>;
  filterExternalProviderBets?: InputMaybe<Scalars['Boolean']['input']>;
  integrationType?: InputMaybe<ProviderIntegrationType>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyOnLastFreebet?: InputMaybe<Scalars['Boolean']['input']>;
  raindropType?: InputMaybe<RaindropTypeEnum>;
  refundOnCreditFail?: InputMaybe<Scalars['Boolean']['input']>;
  retryScheduledSendCredit?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProviderStatus>;
  syncFreebet?: InputMaybe<Scalars['Boolean']['input']>;
  syncRaindrop?: InputMaybe<Scalars['Boolean']['input']>;
  syncRoundEnd?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProviderConfigArgs = {
  betSuggestions?: InputMaybe<Array<Scalars['Float']['input']>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  defaultAutoCashout?: InputMaybe<Scalars['Float']['input']>;
  defaultBet?: InputMaybe<Scalars['Float']['input']>;
  isRoundable?: InputMaybe<Scalars['Boolean']['input']>;
  maxAutoCashout?: InputMaybe<Scalars['Float']['input']>;
  maxBet?: InputMaybe<Scalars['Float']['input']>;
  maxWin?: InputMaybe<Scalars['Float']['input']>;
  minAutoCashout?: InputMaybe<Scalars['Float']['input']>;
  minBet?: InputMaybe<Scalars['Float']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  allowedRoleIds?: Maybe<Array<Scalars['String']['output']>>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isProviderUsersAdmin?: Maybe<Scalars['Boolean']['output']>;
  password: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerRgs?: Maybe<Array<UserProviderRgs>>;
  roleIds: Array<Scalars['String']['output']>;
};

export type UserProviderRgs = {
  __typename?: 'UserProviderRgs';
  providerIds: Array<Scalars['String']['output']>;
  rgsId: Rgs;
};

export type AggregatedAviatorAnalyticsQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
}>;

export type AggregatedAviatorAnalyticsQuery = {
  __typename?: 'Query';
  aggregatedAviatorAnalytics: {
    __typename?: 'AggregatedAviatorAnalytics';
    totalRoundByDate: any;
    records: Array<{
      __typename?: 'AggregatedRoundTransaction';
      totalBetAmount?: number | null;
      totalWonAmount?: number | null;
      date?: string | null;
      providerId?: string | null;
      numberOfUsers?: number | null;
      totalLosingBets?: number | null;
      totalWinningBets?: number | null;
      largestBetAmount?: number | null;
      largestWin?: number | null;
      lowestBetAmount?: number | null;
      lowestWin?: number | null;
      averageBetAmount?: number | null;
      averageWinAmount?: number | null;
      numberOfRounds?: number | null;
    }>;
  };
};

export type PaginatedFreeBetsCampaignsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  search: Scalars['String']['input'];
  filter: InputFilterFreeBetsCampagins;
}>;

export type PaginatedFreeBetsCampaignsQuery = {
  __typename?: 'Query';
  paginatedFreeBetsCampaigns: {
    __typename?: 'PaginatedFreeBetsCampaigns';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'FreeBetsCampaign';
      _id: string;
      description: string;
      providerId: string;
      startDate: any;
      endDate: any;
      campaignUniqueId: string;
      status: string;
      createdAt: any;
      updatedAt: any;
    }>;
  };
};

export type PaginatedFreeBetsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  filter: InputFilterFreeBetsUsage;
  search: Scalars['String']['input'];
}>;

export type PaginatedFreeBetsQuery = {
  __typename?: 'Query';
  paginatedFreeBets: {
    __typename?: 'PaginatedFreeBets';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'FreeBetsUsage';
      _id: string;
      campaignId: string;
      requestId: string;
      providerId: string;
      playerId: string;
      usage: number;
      totalWin: number;
      validityDate: any;
      description: string;
      count: number;
      minMultiplier: number;
      betNominal: number;
      status: string;
      createdAt: any;
    }>;
  };
};

export type PaginatedFreeBetsUsageLogsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  filter: InputFilterFreeBetUsageLogs;
}>;

export type PaginatedFreeBetsUsageLogsQuery = {
  __typename?: 'Query';
  paginatedFreeBetsUsageLogs: {
    __typename?: 'PaginatedFreeBetsUsageLogs';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'FreeBetsUsageLog';
      _id: string;
      campaignId: string;
      usageId: string;
      providerId: string;
      roundId: string;
      gameId: number;
      win: number;
      createdAt: any;
      updatedAt: any;
    }>;
  };
};

export type CreateFreeBetCampaignMutationVariables = Exact<{
  input: CreateFreeBetCampaignInput;
}>;

export type CreateFreeBetCampaignMutation = {
  __typename?: 'Mutation';
  createFreeBetCampaign: { __typename?: 'FreeBetsCampaign'; _id: string };
};

export type UpdateFreeBetCampaignMutationVariables = Exact<{
  input: UpdateFreeBetCampaignInput;
}>;

export type UpdateFreeBetCampaignMutation = {
  __typename?: 'Mutation';
  updateFreeBetCampaign: boolean;
};

export type RevokeSpecificFreeBetMutationVariables = Exact<{
  input: RevokeCampaignFreeBetInput;
}>;

export type RevokeSpecificFreeBetMutation = {
  __typename?: 'Mutation';
  revokeSpecificFreeBet: boolean;
};

export type GetLocalizationQueryVariables = Exact<{
  language: Scalars['String']['input'];
  gameId: Scalars['Float']['input'];
}>;

export type GetLocalizationQuery = {
  __typename?: 'Query';
  localization?: {
    __typename?: 'Localization';
    _id: string;
    language: string;
    translations: string;
    gameId: number;
  } | null;
};

export type UpdateLocalizationMutationVariables = Exact<{
  input: InputUpdateLocalization;
}>;

export type UpdateLocalizationMutation = { __typename?: 'Mutation'; updateLocalization: boolean };

export type LocalizationsQueryVariables = Exact<{
  languages?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type LocalizationsQuery = {
  __typename?: 'Query';
  localizations?: {
    __typename?: 'LocalizationObjectType';
    translations: string;
    languages?: Array<string> | null;
  } | null;
};

export type ExportLocalizationsQueryVariables = Exact<{
  languages?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type ExportLocalizationsQuery = {
  __typename?: 'Query';
  exportLocalizations?: string | null;
};

export type AddLocalizationKeyMutationVariables = Exact<{
  input: InputUpdateLocalization;
}>;

export type AddLocalizationKeyMutation = { __typename?: 'Mutation'; addLocalizationKey: boolean };

export type AddNewLanguageMutationVariables = Exact<{
  newLanguage: Scalars['String']['input'];
}>;

export type AddNewLanguageMutation = { __typename?: 'Mutation'; addNewLanguage?: boolean | null };

export type GetProvidersQueryVariables = Exact<{
  filters?: InputMaybe<InputProviderFilter>;
}>;

export type GetProvidersQuery = {
  __typename?: 'Query';
  providers: Array<{
    __typename?: 'Provider';
    id: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    name: string;
    apiUrl: string;
    syncRoundEnd?: boolean | null;
    status?: ProviderStatus | null;
    retryScheduledSendCredit?: boolean | null;
    refundOnCreditFail?: boolean | null;
    filterExternalProviderBets?: boolean | null;
    isInternal?: boolean | null;
    integrationType?: ProviderIntegrationType | null;
    rgsId?: Rgs | null;
    syncRaindrop?: boolean | null;
    syncFreebet?: boolean | null;
    notifyOnLastFreebet?: boolean | null;
    raindropType?: RaindropTypeEnum | null;
  }>;
};

export type CreateProviderMutationVariables = Exact<{
  input: CreateProviderArgs;
}>;

export type CreateProviderMutation = {
  __typename?: 'Mutation';
  createProvider: { __typename?: 'Provider'; id: string; name: string };
};

export type GetProviderQueryVariables = Exact<{
  providerId: Scalars['String']['input'];
}>;

export type GetProviderQuery = {
  __typename?: 'Query';
  provider?: {
    __typename?: 'Provider';
    id: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    name: string;
    apiUrl: string;
    syncRoundEnd?: boolean | null;
    status?: ProviderStatus | null;
    retryScheduledSendCredit?: boolean | null;
    refundOnCreditFail?: boolean | null;
    filterExternalProviderBets?: boolean | null;
    isInternal?: boolean | null;
    integrationType?: ProviderIntegrationType | null;
    rgsId?: Rgs | null;
    syncRaindrop?: boolean | null;
    syncFreebet?: boolean | null;
    notifyOnLastFreebet?: boolean | null;
    enableInactivityScreen?: boolean | null;
    raindropType?: RaindropTypeEnum | null;
  } | null;
};

export type UpdateProviderMutationVariables = Exact<{
  providerId: Scalars['String']['input'];
  input: UpdateProviderArgs;
}>;

export type UpdateProviderMutation = { __typename?: 'Mutation'; updateProvider: number };

export type GetProviderConfigsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetProviderConfigsQuery = {
  __typename?: 'Query';
  providerConfigs: Array<{
    __typename?: 'ProviderConfig';
    id: string;
    providerId?: string | null;
    createdAt: any;
    updatedAt: any;
    maxWin: number;
    minBet: number;
    maxBet: number;
    betSuggestions: Array<number>;
    minAutoCashout?: number | null;
    defaultAutoCashout?: number | null;
    maxAutoCashout?: number | null;
    defaultBet: number;
    currency: string;
    isRoundable: boolean;
  }>;
};

export type GetProviderPublicKeyQueryVariables = Exact<{
  providerId: Scalars['String']['input'];
}>;

export type GetProviderPublicKeyQuery = { __typename?: 'Query'; providerPublicKey?: string | null };

export type CreateProviderConfigMutationVariables = Exact<{
  input: CreateProviderConfigArgs;
}>;

export type CreateProviderConfigMutation = {
  __typename?: 'Mutation';
  createProviderConfig: { __typename?: 'ProviderConfig'; id: string };
};

export type UpdateProviderConfigMutationVariables = Exact<{
  configId: Scalars['String']['input'];
  input: UpdateProviderConfigArgs;
}>;

export type UpdateProviderConfigMutation = {
  __typename?: 'Mutation';
  updateProviderConfig: number;
};

export type DeleteProviderConfigMutationVariables = Exact<{
  configId: Scalars['String']['input'];
}>;

export type DeleteProviderConfigMutation = {
  __typename?: 'Mutation';
  deleteProviderConfig: number;
};

export type GetProvidersFromAllRgsQueryVariables = Exact<{ [key: string]: never }>;

export type GetProvidersFromAllRgsQuery = {
  __typename?: 'Query';
  providersFromAllRGS: Array<{
    __typename?: 'ProviderRgs';
    rgsId: Rgs;
    providerId: string;
    providerName: string;
  }>;
};

export type CreateRaindropCampaignMutationVariables = Exact<{
  input: CreateRaindropCampaignInput;
}>;

export type CreateRaindropCampaignMutation = {
  __typename?: 'Mutation';
  createRaindropCampaign: {
    __typename?: 'CreateRaindropCampaignType';
    id?: string | null;
    status?: string | null;
    message?: string | null;
  };
};

export type RaindropCampaignsQueryVariables = Exact<{
  filter?: InputMaybe<RaindropCampaignFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;

export type RaindropCampaignsQuery = {
  __typename?: 'Query';
  raindropCampaigns: {
    __typename?: 'PaginatedRaindropCampaign';
    total: number;
    limit: number;
    page: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'RaindropCampaignType';
      id?: string | null;
      name: string;
      providerId: string;
      casinoId?: string | null;
      startDate: any;
      endDate: any;
      currency: string;
      freebetValue: number;
      dayBudget?: number | null;
      totalBudget?: number | null;
      claimLimitNumber: number;
      status: RaindropCampaignStatus;
      distributionFrom: string;
      distributionTo: string;
      freebetsPerRain: number;
      rainsPerDay: number;
      claimLimitPeriod?: ClaimLimitPeriod | null;
      minMultiplier: number;
      freebetValidityDate: any;
      claimDeadlineMinutes: number;
      playerMinBalance?: number | null;
      playerMinWager?: number | null;
      wagerPeriod?: number | null;
      timezone: string;
    }>;
  };
};

export type CancelRaindropCampaignMutationVariables = Exact<{
  campaignId: Scalars['String']['input'];
}>;

export type CancelRaindropCampaignMutation = {
  __typename?: 'Mutation';
  cancelRaindropCampaign: {
    __typename?: 'CancelRaindropCampaignType';
    status?: string | null;
    message?: string | null;
  };
};

export type UpdateRoundStatusMutationVariables = Exact<{
  input: InputUpdateRoundStatus;
}>;

export type UpdateRoundStatusMutation = { __typename?: 'Mutation'; updateRoundStatus: boolean };

export type PaginatedAviatorRoundsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  filter?: InputMaybe<InputFilterRounds>;
}>;

export type PaginatedAviatorRoundsQuery = {
  __typename?: 'Query';
  paginatedAviatorRounds: {
    __typename?: 'PaginatedRounds';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'Round';
      _id?: string | null;
      multiplierCrash?: number | null;
      createdAt: any;
      roundHash?: string | null;
      clientHash?: string | null;
      serverHash?: string | null;
    }>;
  };
};

export type AviatorLiveRoundStatusQueryVariables = Exact<{ [key: string]: never }>;

export type AviatorLiveRoundStatusQuery = { __typename?: 'Query'; aviatorLiveRoundStatus: string };

export type PaginatedAviatorPlayerIdsRoundsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<InputFilterPlayerIds>;
}>;

export type PaginatedAviatorPlayerIdsRoundsQuery = {
  __typename?: 'Query';
  paginatedAviatorPlayerIdsRounds: {
    __typename?: 'PaginatedProviderPlayers';
    docs: Array<{ __typename?: 'RoundPlayer'; playerId: string; username: string }>;
  };
};

export type TestProviderMutationVariables = Exact<{
  testProviderInput: TestProvidersInput;
}>;

export type TestProviderMutation = {
  __typename?: 'Mutation';
  testProvider: {
    __typename?: 'TestProviderResponseObjectType';
    errorsCount?: number | null;
    message: string;
    data?: Array<{
      __typename?: 'TestCheck';
      endpoint: string;
      testCase?: string | null;
      errors?: Array<{ __typename?: 'ErrorsType'; err: string }> | null;
    }> | null;
  };
};

export type PaginatedAviatorRoundTransactionsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  filter: InputFilterRoundTransaction;
}>;

export type PaginatedAviatorRoundTransactionsQuery = {
  __typename?: 'Query';
  paginatedAviatorRoundTransactions: {
    __typename?: 'PaginatedTransactions';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'RoundTransaction';
      _id?: string | null;
      providerId: string;
      freebetUsageLogId?: string | null;
      playerId: string;
      roundId: string;
      win?: number | null;
      username: string;
      betAmount: number;
      multiplier?: number | null;
      cashoutDate?: any | null;
      isAutoCashout: boolean;
      maxMultiplier?: number | null;
      roundHash?: string | null;
      serverHash?: string | null;
      clientHash?: string | null;
      playerRoundBetId: string;
      createdAt: any;
      language?: string | null;
      currency?: string | null;
    }>;
  };
};

export type PaginatedProviderTransactionsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  filter: InputFilterProviderTransaction;
}>;

export type PaginatedProviderTransactionsQuery = {
  __typename?: 'Query';
  paginatedProviderTransactions: {
    __typename?: 'PaginatedProviderTransactions';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'ProviderTransaction';
      _id: string;
      createdAt?: any | null;
      category: string;
      language?: string | null;
      currency?: string | null;
      roundId: string;
      transactionId?: string | null;
      operation: string;
      reason?: string | null;
      providerId: string;
      playerId: string;
      amount: number;
      multiplier?: number | null;
      balance: number;
      gameId: number;
    }>;
  };
};

export type PaginatedProviderIgnoredRequestsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  filter: InputFilterIgnoredRequests;
}>;

export type PaginatedProviderIgnoredRequestsQuery = {
  __typename?: 'Query';
  paginatedProviderIgnoredRequests: {
    __typename?: 'PaginatedProviderIgnoredRequests';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'ProviderIgnoredRequests';
      createdAt: any;
      reason: string;
      operation: string;
      playerId: string;
      roundId: string;
      betId: string;
      betAmount?: string | null;
      providerId: string;
      startDate: any;
      endDate: any;
    }>;
  };
};

export type FailedSendCreditTasksQueryVariables = Exact<{ [key: string]: never }>;

export type FailedSendCreditTasksQuery = {
  __typename?: 'Query';
  aviatorFailedSendCreditTasks: Array<{
    __typename?: 'FailedSendCreditTask';
    id: string;
    attempts: number;
    finishedOn?: number | null;
    processedOn?: number | null;
    failedReason?: string | null;
    data?: {
      __typename?: 'FailedSendCreditTaskData';
      transactionId: string;
      roundId: string;
      providerId: string;
      playerId: string;
      betId: string;
    } | null;
  }>;
};

export type FailedSendCreditTransactionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<InputFilterProviderFailedTransactions>;
}>;

export type FailedSendCreditTransactionsQuery = {
  __typename?: 'Query';
  aviatorFailedProviderSendCreditTransactions: {
    __typename?: 'PaginatedFailedTransactions';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'ProviderFailedSendCreditTransaction';
      _id: string;
      createdAt?: any | null;
      category: string;
      language?: string | null;
      currency?: string | null;
      roundId: string;
      transactionId?: string | null;
      operation: string;
      reason?: string | null;
      providerId: string;
      playerId: string;
      amount: number;
      multiplier?: number | null;
      gameId: number;
      previousTransactionId?: string | null;
      awardId?: string | null;
      errorMessage?: string | null;
      isResolved?: boolean | null;
    }>;
  };
};

export type ScheduledSendCreditTasksQueryVariables = Exact<{ [key: string]: never }>;

export type ScheduledSendCreditTasksQuery = {
  __typename?: 'Query';
  aviatorScheduledSendCreditTasks: Array<{
    __typename?: 'ScheduledSendCreditTask';
    id: string;
    delayMs?: number | null;
    createdAt?: any | null;
    data?: {
      __typename?: 'ScheduledSendCreditTaskData';
      apiUrl: string;
      transactionId: string;
      roundId: string;
      amount: number;
      language: string;
      currency: string;
      reason: string;
      category: string;
      providerId: string;
      gameId: number;
      operation: string;
      playerId: string;
      multiplier?: number | null;
      betId: string;
    } | null;
  }>;
};

export type GetUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetUsersQuery = {
  __typename?: 'Query';
  users: Array<{
    __typename?: 'User';
    id: string;
    email: string;
    providerId: string;
    roleIds: Array<string>;
    isProviderUsersAdmin?: boolean | null;
    providerRgs?: Array<{
      __typename?: 'UserProviderRgs';
      rgsId: Rgs;
      providerIds: Array<string>;
    }> | null;
  }>;
};

export type GetUserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    email: string;
    providerId: string;
    roleIds: Array<string>;
    isProviderUsersAdmin?: boolean | null;
    allowedRoleIds?: Array<string> | null;
    providerRgs?: Array<{
      __typename?: 'UserProviderRgs';
      rgsId: Rgs;
      providerIds: Array<string>;
    }> | null;
  } | null;
};

export type UpdateUserMutationVariables = Exact<{
  input: InputUpdateUser;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser: { __typename?: 'User'; id: string };
};

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;

export type DeleteUserMutation = { __typename?: 'Mutation'; deleteUser: number };

export type GetRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetRolesQuery = {
  __typename?: 'Query';
  roles: Array<{
    __typename?: 'Role';
    id: string;
    name: string;
    description: string;
    permissions: Array<string>;
    isEditable: boolean;
  }>;
};

export type GetRoleQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetRoleQuery = {
  __typename?: 'Query';
  role?: {
    __typename?: 'Role';
    id: string;
    name: string;
    description: string;
    permissions: Array<string>;
  } | null;
};

export type GetPermissionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPermissionsQuery = { __typename?: 'Query'; permissions: Array<string> };

export type CreateRoleMutationVariables = Exact<{
  input: InputCreateRole;
}>;

export type CreateRoleMutation = {
  __typename?: 'Mutation';
  createRole: { __typename?: 'Role'; id: string };
};

export type CreateUserMutationVariables = Exact<{
  input: InputCreateUser;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutation';
  createUser: { __typename?: 'User'; id: string };
};

export type DeleteRoleMutationVariables = Exact<{
  input: InputDeleteRole;
}>;

export type DeleteRoleMutation = { __typename?: 'Mutation'; deleteRole: number };

export type GetSessionQueryVariables = Exact<{ [key: string]: never }>;

export type GetSessionQuery = {
  __typename?: 'Query';
  session: {
    __typename?: 'BackOfficeSession';
    provider?: { __typename?: 'Provider'; id: string; name: string } | null;
    session: {
      __typename?: 'Session';
      id: string;
      email?: string | null;
      providerIds?: Array<string> | null;
      permissions: Array<string>;
      isSuper?: boolean | null;
      rgsIds?: Array<Rgs> | null;
      isProviderUsersAdmin?: boolean | null;
      allowedRoleIds?: Array<string> | null;
    };
  };
};

export type SignInMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type SignInMutation = {
  __typename?: 'Mutation';
  signIn: { __typename?: 'AuthPayload'; accessToken: string; refreshToken: string };
};

export type RefreshTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type RefreshTokenMutation = {
  __typename?: 'Mutation';
  refreshToken: { __typename?: 'AuthPayload'; accessToken: string; refreshToken: string };
};

export type CreateAviatorPermissionMutationVariables = Exact<{
  permission: Scalars['String']['input'];
}>;

export type CreateAviatorPermissionMutation = { __typename?: 'Mutation'; addPermission: number };

export type DeleteSelectedRolePermissionMutationVariables = Exact<{
  input: InputRemoveRolePermission;
}>;

export type DeleteSelectedRolePermissionMutation = {
  __typename?: 'Mutation';
  removeRolePermission: number;
};

export type AssignRolePermissionsMutationVariables = Exact<{
  input: InputAssignRolePermissions;
}>;

export type AssignRolePermissionsMutation = {
  __typename?: 'Mutation';
  assignRolePermissions: boolean;
};

export const AggregatedAviatorAnalyticsDocument = gql`
  query aggregatedAviatorAnalytics($start: DateTime!, $end: DateTime!, $providerId: String) {
    aggregatedAviatorAnalytics(start: $start, end: $end, providerId: $providerId) {
      totalRoundByDate
      records {
        totalBetAmount
        totalWonAmount
        date
        providerId
        numberOfUsers
        totalLosingBets
        totalWinningBets
        largestBetAmount
        largestWin
        lowestBetAmount
        lowestWin
        averageBetAmount
        averageWinAmount
        numberOfRounds
      }
    }
  }
`;

/**
 * __useAggregatedAviatorAnalyticsQuery__
 *
 * To run a query within a React component, call `useAggregatedAviatorAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregatedAviatorAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregatedAviatorAnalyticsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useAggregatedAviatorAnalyticsQuery(
  baseOptions: Apollo.QueryHookOptions<
    AggregatedAviatorAnalyticsQuery,
    AggregatedAviatorAnalyticsQueryVariables
  > &
    ({ variables: AggregatedAviatorAnalyticsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AggregatedAviatorAnalyticsQuery, AggregatedAviatorAnalyticsQueryVariables>(
    AggregatedAviatorAnalyticsDocument,
    options
  );
}
export function useAggregatedAviatorAnalyticsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AggregatedAviatorAnalyticsQuery,
    AggregatedAviatorAnalyticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AggregatedAviatorAnalyticsQuery,
    AggregatedAviatorAnalyticsQueryVariables
  >(AggregatedAviatorAnalyticsDocument, options);
}
export function useAggregatedAviatorAnalyticsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AggregatedAviatorAnalyticsQuery,
    AggregatedAviatorAnalyticsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AggregatedAviatorAnalyticsQuery,
    AggregatedAviatorAnalyticsQueryVariables
  >(AggregatedAviatorAnalyticsDocument, options);
}
export type AggregatedAviatorAnalyticsQueryHookResult = ReturnType<
  typeof useAggregatedAviatorAnalyticsQuery
>;
export type AggregatedAviatorAnalyticsLazyQueryHookResult = ReturnType<
  typeof useAggregatedAviatorAnalyticsLazyQuery
>;
export type AggregatedAviatorAnalyticsSuspenseQueryHookResult = ReturnType<
  typeof useAggregatedAviatorAnalyticsSuspenseQuery
>;
export type AggregatedAviatorAnalyticsQueryResult = Apollo.QueryResult<
  AggregatedAviatorAnalyticsQuery,
  AggregatedAviatorAnalyticsQueryVariables
>;
export const PaginatedFreeBetsCampaignsDocument = gql`
  query paginatedFreeBetsCampaigns(
    $limit: Float!
    $page: Float!
    $search: String!
    $filter: InputFilterFreeBetsCampagins!
  ) {
    paginatedFreeBetsCampaigns(limit: $limit, page: $page, search: $search, filter: $filter) {
      total
      page
      limit
      skip
      docs {
        _id
        description
        providerId
        startDate
        endDate
        campaignUniqueId
        status
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __usePaginatedFreeBetsCampaignsQuery__
 *
 * To run a query within a React component, call `usePaginatedFreeBetsCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedFreeBetsCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedFreeBetsCampaignsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedFreeBetsCampaignsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaginatedFreeBetsCampaignsQuery,
    PaginatedFreeBetsCampaignsQueryVariables
  > &
    ({ variables: PaginatedFreeBetsCampaignsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaginatedFreeBetsCampaignsQuery, PaginatedFreeBetsCampaignsQueryVariables>(
    PaginatedFreeBetsCampaignsDocument,
    options
  );
}
export function usePaginatedFreeBetsCampaignsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedFreeBetsCampaignsQuery,
    PaginatedFreeBetsCampaignsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaginatedFreeBetsCampaignsQuery,
    PaginatedFreeBetsCampaignsQueryVariables
  >(PaginatedFreeBetsCampaignsDocument, options);
}
export function usePaginatedFreeBetsCampaignsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedFreeBetsCampaignsQuery,
    PaginatedFreeBetsCampaignsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PaginatedFreeBetsCampaignsQuery,
    PaginatedFreeBetsCampaignsQueryVariables
  >(PaginatedFreeBetsCampaignsDocument, options);
}
export type PaginatedFreeBetsCampaignsQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsCampaignsQuery
>;
export type PaginatedFreeBetsCampaignsLazyQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsCampaignsLazyQuery
>;
export type PaginatedFreeBetsCampaignsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsCampaignsSuspenseQuery
>;
export type PaginatedFreeBetsCampaignsQueryResult = Apollo.QueryResult<
  PaginatedFreeBetsCampaignsQuery,
  PaginatedFreeBetsCampaignsQueryVariables
>;
export const PaginatedFreeBetsDocument = gql`
  query paginatedFreeBets(
    $limit: Float!
    $page: Float!
    $filter: InputFilterFreeBetsUsage!
    $search: String!
  ) {
    paginatedFreeBets(limit: $limit, page: $page, filter: $filter, search: $search) {
      total
      page
      limit
      skip
      docs {
        _id
        campaignId
        requestId
        providerId
        playerId
        usage
        totalWin
        validityDate
        description
        count
        minMultiplier
        betNominal
        status
        createdAt
      }
    }
  }
`;

/**
 * __usePaginatedFreeBetsQuery__
 *
 * To run a query within a React component, call `usePaginatedFreeBetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedFreeBetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedFreeBetsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePaginatedFreeBetsQuery(
  baseOptions: Apollo.QueryHookOptions<PaginatedFreeBetsQuery, PaginatedFreeBetsQueryVariables> &
    ({ variables: PaginatedFreeBetsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaginatedFreeBetsQuery, PaginatedFreeBetsQueryVariables>(
    PaginatedFreeBetsDocument,
    options
  );
}
export function usePaginatedFreeBetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PaginatedFreeBetsQuery, PaginatedFreeBetsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PaginatedFreeBetsQuery, PaginatedFreeBetsQueryVariables>(
    PaginatedFreeBetsDocument,
    options
  );
}
export function usePaginatedFreeBetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedFreeBetsQuery,
    PaginatedFreeBetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PaginatedFreeBetsQuery, PaginatedFreeBetsQueryVariables>(
    PaginatedFreeBetsDocument,
    options
  );
}
export type PaginatedFreeBetsQueryHookResult = ReturnType<typeof usePaginatedFreeBetsQuery>;
export type PaginatedFreeBetsLazyQueryHookResult = ReturnType<typeof usePaginatedFreeBetsLazyQuery>;
export type PaginatedFreeBetsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsSuspenseQuery
>;
export type PaginatedFreeBetsQueryResult = Apollo.QueryResult<
  PaginatedFreeBetsQuery,
  PaginatedFreeBetsQueryVariables
>;
export const PaginatedFreeBetsUsageLogsDocument = gql`
  query paginatedFreeBetsUsageLogs(
    $limit: Float!
    $page: Float!
    $filter: InputFilterFreeBetUsageLogs!
  ) {
    paginatedFreeBetsUsageLogs(limit: $limit, page: $page, filter: $filter) {
      total
      page
      limit
      skip
      docs {
        _id
        campaignId
        usageId
        providerId
        roundId
        gameId
        win
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __usePaginatedFreeBetsUsageLogsQuery__
 *
 * To run a query within a React component, call `usePaginatedFreeBetsUsageLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedFreeBetsUsageLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedFreeBetsUsageLogsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedFreeBetsUsageLogsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaginatedFreeBetsUsageLogsQuery,
    PaginatedFreeBetsUsageLogsQueryVariables
  > &
    ({ variables: PaginatedFreeBetsUsageLogsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaginatedFreeBetsUsageLogsQuery, PaginatedFreeBetsUsageLogsQueryVariables>(
    PaginatedFreeBetsUsageLogsDocument,
    options
  );
}
export function usePaginatedFreeBetsUsageLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedFreeBetsUsageLogsQuery,
    PaginatedFreeBetsUsageLogsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaginatedFreeBetsUsageLogsQuery,
    PaginatedFreeBetsUsageLogsQueryVariables
  >(PaginatedFreeBetsUsageLogsDocument, options);
}
export function usePaginatedFreeBetsUsageLogsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedFreeBetsUsageLogsQuery,
    PaginatedFreeBetsUsageLogsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PaginatedFreeBetsUsageLogsQuery,
    PaginatedFreeBetsUsageLogsQueryVariables
  >(PaginatedFreeBetsUsageLogsDocument, options);
}
export type PaginatedFreeBetsUsageLogsQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsUsageLogsQuery
>;
export type PaginatedFreeBetsUsageLogsLazyQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsUsageLogsLazyQuery
>;
export type PaginatedFreeBetsUsageLogsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsUsageLogsSuspenseQuery
>;
export type PaginatedFreeBetsUsageLogsQueryResult = Apollo.QueryResult<
  PaginatedFreeBetsUsageLogsQuery,
  PaginatedFreeBetsUsageLogsQueryVariables
>;
export const CreateFreeBetCampaignDocument = gql`
  mutation createFreeBetCampaign($input: CreateFreeBetCampaignInput!) {
    createFreeBetCampaign(input: $input) {
      _id
    }
  }
`;
export type CreateFreeBetCampaignMutationFn = Apollo.MutationFunction<
  CreateFreeBetCampaignMutation,
  CreateFreeBetCampaignMutationVariables
>;

/**
 * __useCreateFreeBetCampaignMutation__
 *
 * To run a mutation, you first call `useCreateFreeBetCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFreeBetCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFreeBetCampaignMutation, { data, loading, error }] = useCreateFreeBetCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFreeBetCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFreeBetCampaignMutation,
    CreateFreeBetCampaignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateFreeBetCampaignMutation, CreateFreeBetCampaignMutationVariables>(
    CreateFreeBetCampaignDocument,
    options
  );
}
export type CreateFreeBetCampaignMutationHookResult = ReturnType<
  typeof useCreateFreeBetCampaignMutation
>;
export type CreateFreeBetCampaignMutationResult =
  Apollo.MutationResult<CreateFreeBetCampaignMutation>;
export type CreateFreeBetCampaignMutationOptions = Apollo.BaseMutationOptions<
  CreateFreeBetCampaignMutation,
  CreateFreeBetCampaignMutationVariables
>;
export const UpdateFreeBetCampaignDocument = gql`
  mutation updateFreeBetCampaign($input: UpdateFreeBetCampaignInput!) {
    updateFreeBetCampaign(input: $input)
  }
`;
export type UpdateFreeBetCampaignMutationFn = Apollo.MutationFunction<
  UpdateFreeBetCampaignMutation,
  UpdateFreeBetCampaignMutationVariables
>;

/**
 * __useUpdateFreeBetCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateFreeBetCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFreeBetCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFreeBetCampaignMutation, { data, loading, error }] = useUpdateFreeBetCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFreeBetCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFreeBetCampaignMutation,
    UpdateFreeBetCampaignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateFreeBetCampaignMutation, UpdateFreeBetCampaignMutationVariables>(
    UpdateFreeBetCampaignDocument,
    options
  );
}
export type UpdateFreeBetCampaignMutationHookResult = ReturnType<
  typeof useUpdateFreeBetCampaignMutation
>;
export type UpdateFreeBetCampaignMutationResult =
  Apollo.MutationResult<UpdateFreeBetCampaignMutation>;
export type UpdateFreeBetCampaignMutationOptions = Apollo.BaseMutationOptions<
  UpdateFreeBetCampaignMutation,
  UpdateFreeBetCampaignMutationVariables
>;
export const RevokeSpecificFreeBetDocument = gql`
  mutation revokeSpecificFreeBet($input: RevokeCampaignFreeBetInput!) {
    revokeSpecificFreeBet(input: $input)
  }
`;
export type RevokeSpecificFreeBetMutationFn = Apollo.MutationFunction<
  RevokeSpecificFreeBetMutation,
  RevokeSpecificFreeBetMutationVariables
>;

/**
 * __useRevokeSpecificFreeBetMutation__
 *
 * To run a mutation, you first call `useRevokeSpecificFreeBetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeSpecificFreeBetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeSpecificFreeBetMutation, { data, loading, error }] = useRevokeSpecificFreeBetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeSpecificFreeBetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeSpecificFreeBetMutation,
    RevokeSpecificFreeBetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RevokeSpecificFreeBetMutation, RevokeSpecificFreeBetMutationVariables>(
    RevokeSpecificFreeBetDocument,
    options
  );
}
export type RevokeSpecificFreeBetMutationHookResult = ReturnType<
  typeof useRevokeSpecificFreeBetMutation
>;
export type RevokeSpecificFreeBetMutationResult =
  Apollo.MutationResult<RevokeSpecificFreeBetMutation>;
export type RevokeSpecificFreeBetMutationOptions = Apollo.BaseMutationOptions<
  RevokeSpecificFreeBetMutation,
  RevokeSpecificFreeBetMutationVariables
>;
export const GetLocalizationDocument = gql`
  query getLocalization($language: String!, $gameId: Float!) {
    localization(language: $language, gameId: $gameId) {
      _id
      language
      translations
      gameId
    }
  }
`;

/**
 * __useGetLocalizationQuery__
 *
 * To run a query within a React component, call `useGetLocalizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizationQuery({
 *   variables: {
 *      language: // value for 'language'
 *      gameId: // value for 'gameId'
 *   },
 * });
 */
export function useGetLocalizationQuery(
  baseOptions: Apollo.QueryHookOptions<GetLocalizationQuery, GetLocalizationQueryVariables> &
    ({ variables: GetLocalizationQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLocalizationQuery, GetLocalizationQueryVariables>(
    GetLocalizationDocument,
    options
  );
}
export function useGetLocalizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLocalizationQuery, GetLocalizationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLocalizationQuery, GetLocalizationQueryVariables>(
    GetLocalizationDocument,
    options
  );
}
export function useGetLocalizationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocalizationQuery, GetLocalizationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLocalizationQuery, GetLocalizationQueryVariables>(
    GetLocalizationDocument,
    options
  );
}
export type GetLocalizationQueryHookResult = ReturnType<typeof useGetLocalizationQuery>;
export type GetLocalizationLazyQueryHookResult = ReturnType<typeof useGetLocalizationLazyQuery>;
export type GetLocalizationSuspenseQueryHookResult = ReturnType<
  typeof useGetLocalizationSuspenseQuery
>;
export type GetLocalizationQueryResult = Apollo.QueryResult<
  GetLocalizationQuery,
  GetLocalizationQueryVariables
>;
export const UpdateLocalizationDocument = gql`
  mutation updateLocalization($input: InputUpdateLocalization!) {
    updateLocalization(input: $input)
  }
`;
export type UpdateLocalizationMutationFn = Apollo.MutationFunction<
  UpdateLocalizationMutation,
  UpdateLocalizationMutationVariables
>;

/**
 * __useUpdateLocalizationMutation__
 *
 * To run a mutation, you first call `useUpdateLocalizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalizationMutation, { data, loading, error }] = useUpdateLocalizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocalizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLocalizationMutation,
    UpdateLocalizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateLocalizationMutation, UpdateLocalizationMutationVariables>(
    UpdateLocalizationDocument,
    options
  );
}
export type UpdateLocalizationMutationHookResult = ReturnType<typeof useUpdateLocalizationMutation>;
export type UpdateLocalizationMutationResult = Apollo.MutationResult<UpdateLocalizationMutation>;
export type UpdateLocalizationMutationOptions = Apollo.BaseMutationOptions<
  UpdateLocalizationMutation,
  UpdateLocalizationMutationVariables
>;
export const LocalizationsDocument = gql`
  query localizations($languages: [String!]) {
    localizations(languages: $languages) {
      translations
      languages
    }
  }
`;

/**
 * __useLocalizationsQuery__
 *
 * To run a query within a React component, call `useLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalizationsQuery({
 *   variables: {
 *      languages: // value for 'languages'
 *   },
 * });
 */
export function useLocalizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<LocalizationsQuery, LocalizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LocalizationsQuery, LocalizationsQueryVariables>(
    LocalizationsDocument,
    options
  );
}
export function useLocalizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LocalizationsQuery, LocalizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LocalizationsQuery, LocalizationsQueryVariables>(
    LocalizationsDocument,
    options
  );
}
export function useLocalizationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<LocalizationsQuery, LocalizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LocalizationsQuery, LocalizationsQueryVariables>(
    LocalizationsDocument,
    options
  );
}
export type LocalizationsQueryHookResult = ReturnType<typeof useLocalizationsQuery>;
export type LocalizationsLazyQueryHookResult = ReturnType<typeof useLocalizationsLazyQuery>;
export type LocalizationsSuspenseQueryHookResult = ReturnType<typeof useLocalizationsSuspenseQuery>;
export type LocalizationsQueryResult = Apollo.QueryResult<
  LocalizationsQuery,
  LocalizationsQueryVariables
>;
export const ExportLocalizationsDocument = gql`
  query exportLocalizations($languages: [String!]) {
    exportLocalizations(languages: $languages)
  }
`;

/**
 * __useExportLocalizationsQuery__
 *
 * To run a query within a React component, call `useExportLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportLocalizationsQuery({
 *   variables: {
 *      languages: // value for 'languages'
 *   },
 * });
 */
export function useExportLocalizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<ExportLocalizationsQuery, ExportLocalizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportLocalizationsQuery, ExportLocalizationsQueryVariables>(
    ExportLocalizationsDocument,
    options
  );
}
export function useExportLocalizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportLocalizationsQuery,
    ExportLocalizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExportLocalizationsQuery, ExportLocalizationsQueryVariables>(
    ExportLocalizationsDocument,
    options
  );
}
export function useExportLocalizationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportLocalizationsQuery,
    ExportLocalizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExportLocalizationsQuery, ExportLocalizationsQueryVariables>(
    ExportLocalizationsDocument,
    options
  );
}
export type ExportLocalizationsQueryHookResult = ReturnType<typeof useExportLocalizationsQuery>;
export type ExportLocalizationsLazyQueryHookResult = ReturnType<
  typeof useExportLocalizationsLazyQuery
>;
export type ExportLocalizationsSuspenseQueryHookResult = ReturnType<
  typeof useExportLocalizationsSuspenseQuery
>;
export type ExportLocalizationsQueryResult = Apollo.QueryResult<
  ExportLocalizationsQuery,
  ExportLocalizationsQueryVariables
>;
export const AddLocalizationKeyDocument = gql`
  mutation addLocalizationKey($input: InputUpdateLocalization!) {
    addLocalizationKey(input: $input)
  }
`;
export type AddLocalizationKeyMutationFn = Apollo.MutationFunction<
  AddLocalizationKeyMutation,
  AddLocalizationKeyMutationVariables
>;

/**
 * __useAddLocalizationKeyMutation__
 *
 * To run a mutation, you first call `useAddLocalizationKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLocalizationKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLocalizationKeyMutation, { data, loading, error }] = useAddLocalizationKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLocalizationKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddLocalizationKeyMutation,
    AddLocalizationKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddLocalizationKeyMutation, AddLocalizationKeyMutationVariables>(
    AddLocalizationKeyDocument,
    options
  );
}
export type AddLocalizationKeyMutationHookResult = ReturnType<typeof useAddLocalizationKeyMutation>;
export type AddLocalizationKeyMutationResult = Apollo.MutationResult<AddLocalizationKeyMutation>;
export type AddLocalizationKeyMutationOptions = Apollo.BaseMutationOptions<
  AddLocalizationKeyMutation,
  AddLocalizationKeyMutationVariables
>;
export const AddNewLanguageDocument = gql`
  mutation addNewLanguage($newLanguage: String!) {
    addNewLanguage(newLanguage: $newLanguage)
  }
`;
export type AddNewLanguageMutationFn = Apollo.MutationFunction<
  AddNewLanguageMutation,
  AddNewLanguageMutationVariables
>;

/**
 * __useAddNewLanguageMutation__
 *
 * To run a mutation, you first call `useAddNewLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewLanguageMutation, { data, loading, error }] = useAddNewLanguageMutation({
 *   variables: {
 *      newLanguage: // value for 'newLanguage'
 *   },
 * });
 */
export function useAddNewLanguageMutation(
  baseOptions?: Apollo.MutationHookOptions<AddNewLanguageMutation, AddNewLanguageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddNewLanguageMutation, AddNewLanguageMutationVariables>(
    AddNewLanguageDocument,
    options
  );
}
export type AddNewLanguageMutationHookResult = ReturnType<typeof useAddNewLanguageMutation>;
export type AddNewLanguageMutationResult = Apollo.MutationResult<AddNewLanguageMutation>;
export type AddNewLanguageMutationOptions = Apollo.BaseMutationOptions<
  AddNewLanguageMutation,
  AddNewLanguageMutationVariables
>;
export const GetProvidersDocument = gql`
  query getProviders($filters: InputProviderFilter) {
    providers(filters: $filters) {
      id
      createdAt
      updatedAt
      name
      apiUrl
      syncRoundEnd
      status
      retryScheduledSendCredit
      refundOnCreditFail
      filterExternalProviderBets
      isInternal
      integrationType
      rgsId
      syncRaindrop
      syncFreebet
      notifyOnLastFreebet
      raindropType
    }
  }
`;

/**
 * __useGetProvidersQuery__
 *
 * To run a query within a React component, call `useGetProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetProvidersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetProvidersQuery, GetProvidersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProvidersQuery, GetProvidersQueryVariables>(
    GetProvidersDocument,
    options
  );
}
export function useGetProvidersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProvidersQuery, GetProvidersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProvidersQuery, GetProvidersQueryVariables>(
    GetProvidersDocument,
    options
  );
}
export function useGetProvidersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetProvidersQuery, GetProvidersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProvidersQuery, GetProvidersQueryVariables>(
    GetProvidersDocument,
    options
  );
}
export type GetProvidersQueryHookResult = ReturnType<typeof useGetProvidersQuery>;
export type GetProvidersLazyQueryHookResult = ReturnType<typeof useGetProvidersLazyQuery>;
export type GetProvidersSuspenseQueryHookResult = ReturnType<typeof useGetProvidersSuspenseQuery>;
export type GetProvidersQueryResult = Apollo.QueryResult<
  GetProvidersQuery,
  GetProvidersQueryVariables
>;
export const CreateProviderDocument = gql`
  mutation createProvider($input: CreateProviderArgs!) {
    createProvider(input: $input) {
      id
      name
    }
  }
`;
export type CreateProviderMutationFn = Apollo.MutationFunction<
  CreateProviderMutation,
  CreateProviderMutationVariables
>;

/**
 * __useCreateProviderMutation__
 *
 * To run a mutation, you first call `useCreateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderMutation, { data, loading, error }] = useCreateProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateProviderMutation, CreateProviderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateProviderMutation, CreateProviderMutationVariables>(
    CreateProviderDocument,
    options
  );
}
export type CreateProviderMutationHookResult = ReturnType<typeof useCreateProviderMutation>;
export type CreateProviderMutationResult = Apollo.MutationResult<CreateProviderMutation>;
export type CreateProviderMutationOptions = Apollo.BaseMutationOptions<
  CreateProviderMutation,
  CreateProviderMutationVariables
>;
export const GetProviderDocument = gql`
  query getProvider($providerId: String!) {
    provider(providerId: $providerId) {
      id
      createdAt
      updatedAt
      name
      apiUrl
      syncRoundEnd
      status
      retryScheduledSendCredit
      refundOnCreditFail
      filterExternalProviderBets
      isInternal
      integrationType
      rgsId
      syncRaindrop
      syncFreebet
      notifyOnLastFreebet
      enableInactivityScreen
      raindropType
    }
  }
`;

/**
 * __useGetProviderQuery__
 *
 * To run a query within a React component, call `useGetProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetProviderQuery(
  baseOptions: Apollo.QueryHookOptions<GetProviderQuery, GetProviderQueryVariables> &
    ({ variables: GetProviderQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProviderQuery, GetProviderQueryVariables>(GetProviderDocument, options);
}
export function useGetProviderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProviderQuery, GetProviderQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProviderQuery, GetProviderQueryVariables>(
    GetProviderDocument,
    options
  );
}
export function useGetProviderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetProviderQuery, GetProviderQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProviderQuery, GetProviderQueryVariables>(
    GetProviderDocument,
    options
  );
}
export type GetProviderQueryHookResult = ReturnType<typeof useGetProviderQuery>;
export type GetProviderLazyQueryHookResult = ReturnType<typeof useGetProviderLazyQuery>;
export type GetProviderSuspenseQueryHookResult = ReturnType<typeof useGetProviderSuspenseQuery>;
export type GetProviderQueryResult = Apollo.QueryResult<
  GetProviderQuery,
  GetProviderQueryVariables
>;
export const UpdateProviderDocument = gql`
  mutation updateProvider($providerId: String!, $input: UpdateProviderArgs!) {
    updateProvider(providerId: $providerId, input: $input)
  }
`;
export type UpdateProviderMutationFn = Apollo.MutationFunction<
  UpdateProviderMutation,
  UpdateProviderMutationVariables
>;

/**
 * __useUpdateProviderMutation__
 *
 * To run a mutation, you first call `useUpdateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderMutation, { data, loading, error }] = useUpdateProviderMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateProviderMutation, UpdateProviderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateProviderMutation, UpdateProviderMutationVariables>(
    UpdateProviderDocument,
    options
  );
}
export type UpdateProviderMutationHookResult = ReturnType<typeof useUpdateProviderMutation>;
export type UpdateProviderMutationResult = Apollo.MutationResult<UpdateProviderMutation>;
export type UpdateProviderMutationOptions = Apollo.BaseMutationOptions<
  UpdateProviderMutation,
  UpdateProviderMutationVariables
>;
export const GetProviderConfigsDocument = gql`
  query getProviderConfigs($id: String!) {
    providerConfigs(id: $id) {
      id
      providerId
      createdAt
      updatedAt
      maxWin
      minBet
      maxBet
      betSuggestions
      minAutoCashout
      defaultAutoCashout
      maxAutoCashout
      defaultBet
      currency
      isRoundable
    }
  }
`;

/**
 * __useGetProviderConfigsQuery__
 *
 * To run a query within a React component, call `useGetProviderConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderConfigsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProviderConfigsQuery(
  baseOptions: Apollo.QueryHookOptions<GetProviderConfigsQuery, GetProviderConfigsQueryVariables> &
    ({ variables: GetProviderConfigsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProviderConfigsQuery, GetProviderConfigsQueryVariables>(
    GetProviderConfigsDocument,
    options
  );
}
export function useGetProviderConfigsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProviderConfigsQuery,
    GetProviderConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProviderConfigsQuery, GetProviderConfigsQueryVariables>(
    GetProviderConfigsDocument,
    options
  );
}
export function useGetProviderConfigsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProviderConfigsQuery,
    GetProviderConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProviderConfigsQuery, GetProviderConfigsQueryVariables>(
    GetProviderConfigsDocument,
    options
  );
}
export type GetProviderConfigsQueryHookResult = ReturnType<typeof useGetProviderConfigsQuery>;
export type GetProviderConfigsLazyQueryHookResult = ReturnType<
  typeof useGetProviderConfigsLazyQuery
>;
export type GetProviderConfigsSuspenseQueryHookResult = ReturnType<
  typeof useGetProviderConfigsSuspenseQuery
>;
export type GetProviderConfigsQueryResult = Apollo.QueryResult<
  GetProviderConfigsQuery,
  GetProviderConfigsQueryVariables
>;
export const GetProviderPublicKeyDocument = gql`
  query getProviderPublicKey($providerId: String!) {
    providerPublicKey(providerId: $providerId)
  }
`;

/**
 * __useGetProviderPublicKeyQuery__
 *
 * To run a query within a React component, call `useGetProviderPublicKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderPublicKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderPublicKeyQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetProviderPublicKeyQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProviderPublicKeyQuery,
    GetProviderPublicKeyQueryVariables
  > &
    ({ variables: GetProviderPublicKeyQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProviderPublicKeyQuery, GetProviderPublicKeyQueryVariables>(
    GetProviderPublicKeyDocument,
    options
  );
}
export function useGetProviderPublicKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProviderPublicKeyQuery,
    GetProviderPublicKeyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProviderPublicKeyQuery, GetProviderPublicKeyQueryVariables>(
    GetProviderPublicKeyDocument,
    options
  );
}
export function useGetProviderPublicKeySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProviderPublicKeyQuery,
    GetProviderPublicKeyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProviderPublicKeyQuery, GetProviderPublicKeyQueryVariables>(
    GetProviderPublicKeyDocument,
    options
  );
}
export type GetProviderPublicKeyQueryHookResult = ReturnType<typeof useGetProviderPublicKeyQuery>;
export type GetProviderPublicKeyLazyQueryHookResult = ReturnType<
  typeof useGetProviderPublicKeyLazyQuery
>;
export type GetProviderPublicKeySuspenseQueryHookResult = ReturnType<
  typeof useGetProviderPublicKeySuspenseQuery
>;
export type GetProviderPublicKeyQueryResult = Apollo.QueryResult<
  GetProviderPublicKeyQuery,
  GetProviderPublicKeyQueryVariables
>;
export const CreateProviderConfigDocument = gql`
  mutation createProviderConfig($input: CreateProviderConfigArgs!) {
    createProviderConfig(input: $input) {
      id
    }
  }
`;
export type CreateProviderConfigMutationFn = Apollo.MutationFunction<
  CreateProviderConfigMutation,
  CreateProviderConfigMutationVariables
>;

/**
 * __useCreateProviderConfigMutation__
 *
 * To run a mutation, you first call `useCreateProviderConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderConfigMutation, { data, loading, error }] = useCreateProviderConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProviderConfigMutation,
    CreateProviderConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateProviderConfigMutation, CreateProviderConfigMutationVariables>(
    CreateProviderConfigDocument,
    options
  );
}
export type CreateProviderConfigMutationHookResult = ReturnType<
  typeof useCreateProviderConfigMutation
>;
export type CreateProviderConfigMutationResult =
  Apollo.MutationResult<CreateProviderConfigMutation>;
export type CreateProviderConfigMutationOptions = Apollo.BaseMutationOptions<
  CreateProviderConfigMutation,
  CreateProviderConfigMutationVariables
>;
export const UpdateProviderConfigDocument = gql`
  mutation updateProviderConfig($configId: String!, $input: UpdateProviderConfigArgs!) {
    updateProviderConfig(configId: $configId, input: $input)
  }
`;
export type UpdateProviderConfigMutationFn = Apollo.MutationFunction<
  UpdateProviderConfigMutation,
  UpdateProviderConfigMutationVariables
>;

/**
 * __useUpdateProviderConfigMutation__
 *
 * To run a mutation, you first call `useUpdateProviderConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderConfigMutation, { data, loading, error }] = useUpdateProviderConfigMutation({
 *   variables: {
 *      configId: // value for 'configId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProviderConfigMutation,
    UpdateProviderConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateProviderConfigMutation, UpdateProviderConfigMutationVariables>(
    UpdateProviderConfigDocument,
    options
  );
}
export type UpdateProviderConfigMutationHookResult = ReturnType<
  typeof useUpdateProviderConfigMutation
>;
export type UpdateProviderConfigMutationResult =
  Apollo.MutationResult<UpdateProviderConfigMutation>;
export type UpdateProviderConfigMutationOptions = Apollo.BaseMutationOptions<
  UpdateProviderConfigMutation,
  UpdateProviderConfigMutationVariables
>;
export const DeleteProviderConfigDocument = gql`
  mutation deleteProviderConfig($configId: String!) {
    deleteProviderConfig(configId: $configId)
  }
`;
export type DeleteProviderConfigMutationFn = Apollo.MutationFunction<
  DeleteProviderConfigMutation,
  DeleteProviderConfigMutationVariables
>;

/**
 * __useDeleteProviderConfigMutation__
 *
 * To run a mutation, you first call `useDeleteProviderConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderConfigMutation, { data, loading, error }] = useDeleteProviderConfigMutation({
 *   variables: {
 *      configId: // value for 'configId'
 *   },
 * });
 */
export function useDeleteProviderConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProviderConfigMutation,
    DeleteProviderConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteProviderConfigMutation, DeleteProviderConfigMutationVariables>(
    DeleteProviderConfigDocument,
    options
  );
}
export type DeleteProviderConfigMutationHookResult = ReturnType<
  typeof useDeleteProviderConfigMutation
>;
export type DeleteProviderConfigMutationResult =
  Apollo.MutationResult<DeleteProviderConfigMutation>;
export type DeleteProviderConfigMutationOptions = Apollo.BaseMutationOptions<
  DeleteProviderConfigMutation,
  DeleteProviderConfigMutationVariables
>;
export const GetProvidersFromAllRgsDocument = gql`
  query getProvidersFromAllRGS {
    providersFromAllRGS {
      rgsId
      providerId
      providerName
    }
  }
`;

/**
 * __useGetProvidersFromAllRgsQuery__
 *
 * To run a query within a React component, call `useGetProvidersFromAllRgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersFromAllRgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersFromAllRgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProvidersFromAllRgsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProvidersFromAllRgsQuery,
    GetProvidersFromAllRgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProvidersFromAllRgsQuery, GetProvidersFromAllRgsQueryVariables>(
    GetProvidersFromAllRgsDocument,
    options
  );
}
export function useGetProvidersFromAllRgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProvidersFromAllRgsQuery,
    GetProvidersFromAllRgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProvidersFromAllRgsQuery, GetProvidersFromAllRgsQueryVariables>(
    GetProvidersFromAllRgsDocument,
    options
  );
}
export function useGetProvidersFromAllRgsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProvidersFromAllRgsQuery,
    GetProvidersFromAllRgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProvidersFromAllRgsQuery, GetProvidersFromAllRgsQueryVariables>(
    GetProvidersFromAllRgsDocument,
    options
  );
}
export type GetProvidersFromAllRgsQueryHookResult = ReturnType<
  typeof useGetProvidersFromAllRgsQuery
>;
export type GetProvidersFromAllRgsLazyQueryHookResult = ReturnType<
  typeof useGetProvidersFromAllRgsLazyQuery
>;
export type GetProvidersFromAllRgsSuspenseQueryHookResult = ReturnType<
  typeof useGetProvidersFromAllRgsSuspenseQuery
>;
export type GetProvidersFromAllRgsQueryResult = Apollo.QueryResult<
  GetProvidersFromAllRgsQuery,
  GetProvidersFromAllRgsQueryVariables
>;
export const CreateRaindropCampaignDocument = gql`
  mutation createRaindropCampaign($input: CreateRaindropCampaignInput!) {
    createRaindropCampaign(input: $input) {
      id
      status
      message
    }
  }
`;
export type CreateRaindropCampaignMutationFn = Apollo.MutationFunction<
  CreateRaindropCampaignMutation,
  CreateRaindropCampaignMutationVariables
>;

/**
 * __useCreateRaindropCampaignMutation__
 *
 * To run a mutation, you first call `useCreateRaindropCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRaindropCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRaindropCampaignMutation, { data, loading, error }] = useCreateRaindropCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRaindropCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRaindropCampaignMutation,
    CreateRaindropCampaignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateRaindropCampaignMutation,
    CreateRaindropCampaignMutationVariables
  >(CreateRaindropCampaignDocument, options);
}
export type CreateRaindropCampaignMutationHookResult = ReturnType<
  typeof useCreateRaindropCampaignMutation
>;
export type CreateRaindropCampaignMutationResult =
  Apollo.MutationResult<CreateRaindropCampaignMutation>;
export type CreateRaindropCampaignMutationOptions = Apollo.BaseMutationOptions<
  CreateRaindropCampaignMutation,
  CreateRaindropCampaignMutationVariables
>;
export const RaindropCampaignsDocument = gql`
  query raindropCampaigns($filter: RaindropCampaignFilterInput, $pagination: PaginationInput) {
    raindropCampaigns(filter: $filter, pagination: $pagination) {
      total
      limit
      page
      skip
      docs {
        id
        name
        providerId
        casinoId
        startDate
        endDate
        currency
        freebetValue
        dayBudget
        totalBudget
        claimLimitNumber
        status
        distributionFrom
        distributionTo
        freebetsPerRain
        rainsPerDay
        claimLimitNumber
        claimLimitPeriod
        minMultiplier
        freebetValidityDate
        claimDeadlineMinutes
        playerMinBalance
        playerMinWager
        wagerPeriod
        timezone
      }
    }
  }
`;

/**
 * __useRaindropCampaignsQuery__
 *
 * To run a query within a React component, call `useRaindropCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRaindropCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRaindropCampaignsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useRaindropCampaignsQuery(
  baseOptions?: Apollo.QueryHookOptions<RaindropCampaignsQuery, RaindropCampaignsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RaindropCampaignsQuery, RaindropCampaignsQueryVariables>(
    RaindropCampaignsDocument,
    options
  );
}
export function useRaindropCampaignsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RaindropCampaignsQuery, RaindropCampaignsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RaindropCampaignsQuery, RaindropCampaignsQueryVariables>(
    RaindropCampaignsDocument,
    options
  );
}
export function useRaindropCampaignsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RaindropCampaignsQuery,
    RaindropCampaignsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RaindropCampaignsQuery, RaindropCampaignsQueryVariables>(
    RaindropCampaignsDocument,
    options
  );
}
export type RaindropCampaignsQueryHookResult = ReturnType<typeof useRaindropCampaignsQuery>;
export type RaindropCampaignsLazyQueryHookResult = ReturnType<typeof useRaindropCampaignsLazyQuery>;
export type RaindropCampaignsSuspenseQueryHookResult = ReturnType<
  typeof useRaindropCampaignsSuspenseQuery
>;
export type RaindropCampaignsQueryResult = Apollo.QueryResult<
  RaindropCampaignsQuery,
  RaindropCampaignsQueryVariables
>;
export const CancelRaindropCampaignDocument = gql`
  mutation cancelRaindropCampaign($campaignId: String!) {
    cancelRaindropCampaign(campaignId: $campaignId) {
      status
      message
    }
  }
`;
export type CancelRaindropCampaignMutationFn = Apollo.MutationFunction<
  CancelRaindropCampaignMutation,
  CancelRaindropCampaignMutationVariables
>;

/**
 * __useCancelRaindropCampaignMutation__
 *
 * To run a mutation, you first call `useCancelRaindropCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRaindropCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRaindropCampaignMutation, { data, loading, error }] = useCancelRaindropCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCancelRaindropCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelRaindropCampaignMutation,
    CancelRaindropCampaignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelRaindropCampaignMutation,
    CancelRaindropCampaignMutationVariables
  >(CancelRaindropCampaignDocument, options);
}
export type CancelRaindropCampaignMutationHookResult = ReturnType<
  typeof useCancelRaindropCampaignMutation
>;
export type CancelRaindropCampaignMutationResult =
  Apollo.MutationResult<CancelRaindropCampaignMutation>;
export type CancelRaindropCampaignMutationOptions = Apollo.BaseMutationOptions<
  CancelRaindropCampaignMutation,
  CancelRaindropCampaignMutationVariables
>;
export const UpdateRoundStatusDocument = gql`
  mutation updateRoundStatus($input: InputUpdateRoundStatus!) {
    updateRoundStatus(input: $input)
  }
`;
export type UpdateRoundStatusMutationFn = Apollo.MutationFunction<
  UpdateRoundStatusMutation,
  UpdateRoundStatusMutationVariables
>;

/**
 * __useUpdateRoundStatusMutation__
 *
 * To run a mutation, you first call `useUpdateRoundStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoundStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoundStatusMutation, { data, loading, error }] = useUpdateRoundStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoundStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRoundStatusMutation,
    UpdateRoundStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateRoundStatusMutation, UpdateRoundStatusMutationVariables>(
    UpdateRoundStatusDocument,
    options
  );
}
export type UpdateRoundStatusMutationHookResult = ReturnType<typeof useUpdateRoundStatusMutation>;
export type UpdateRoundStatusMutationResult = Apollo.MutationResult<UpdateRoundStatusMutation>;
export type UpdateRoundStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateRoundStatusMutation,
  UpdateRoundStatusMutationVariables
>;
export const PaginatedAviatorRoundsDocument = gql`
  query paginatedAviatorRounds($limit: Float!, $page: Float!, $filter: InputFilterRounds) {
    paginatedAviatorRounds(limit: $limit, page: $page, filter: $filter) {
      total
      page
      limit
      skip
      docs {
        _id
        multiplierCrash
        createdAt
        roundHash
        clientHash
        serverHash
      }
    }
  }
`;

/**
 * __usePaginatedAviatorRoundsQuery__
 *
 * To run a query within a React component, call `usePaginatedAviatorRoundsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedAviatorRoundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedAviatorRoundsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedAviatorRoundsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaginatedAviatorRoundsQuery,
    PaginatedAviatorRoundsQueryVariables
  > &
    ({ variables: PaginatedAviatorRoundsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaginatedAviatorRoundsQuery, PaginatedAviatorRoundsQueryVariables>(
    PaginatedAviatorRoundsDocument,
    options
  );
}
export function usePaginatedAviatorRoundsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedAviatorRoundsQuery,
    PaginatedAviatorRoundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PaginatedAviatorRoundsQuery, PaginatedAviatorRoundsQueryVariables>(
    PaginatedAviatorRoundsDocument,
    options
  );
}
export function usePaginatedAviatorRoundsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedAviatorRoundsQuery,
    PaginatedAviatorRoundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PaginatedAviatorRoundsQuery, PaginatedAviatorRoundsQueryVariables>(
    PaginatedAviatorRoundsDocument,
    options
  );
}
export type PaginatedAviatorRoundsQueryHookResult = ReturnType<
  typeof usePaginatedAviatorRoundsQuery
>;
export type PaginatedAviatorRoundsLazyQueryHookResult = ReturnType<
  typeof usePaginatedAviatorRoundsLazyQuery
>;
export type PaginatedAviatorRoundsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedAviatorRoundsSuspenseQuery
>;
export type PaginatedAviatorRoundsQueryResult = Apollo.QueryResult<
  PaginatedAviatorRoundsQuery,
  PaginatedAviatorRoundsQueryVariables
>;
export const AviatorLiveRoundStatusDocument = gql`
  query aviatorLiveRoundStatus {
    aviatorLiveRoundStatus
  }
`;

/**
 * __useAviatorLiveRoundStatusQuery__
 *
 * To run a query within a React component, call `useAviatorLiveRoundStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAviatorLiveRoundStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAviatorLiveRoundStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useAviatorLiveRoundStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AviatorLiveRoundStatusQuery,
    AviatorLiveRoundStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AviatorLiveRoundStatusQuery, AviatorLiveRoundStatusQueryVariables>(
    AviatorLiveRoundStatusDocument,
    options
  );
}
export function useAviatorLiveRoundStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AviatorLiveRoundStatusQuery,
    AviatorLiveRoundStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AviatorLiveRoundStatusQuery, AviatorLiveRoundStatusQueryVariables>(
    AviatorLiveRoundStatusDocument,
    options
  );
}
export function useAviatorLiveRoundStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AviatorLiveRoundStatusQuery,
    AviatorLiveRoundStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AviatorLiveRoundStatusQuery, AviatorLiveRoundStatusQueryVariables>(
    AviatorLiveRoundStatusDocument,
    options
  );
}
export type AviatorLiveRoundStatusQueryHookResult = ReturnType<
  typeof useAviatorLiveRoundStatusQuery
>;
export type AviatorLiveRoundStatusLazyQueryHookResult = ReturnType<
  typeof useAviatorLiveRoundStatusLazyQuery
>;
export type AviatorLiveRoundStatusSuspenseQueryHookResult = ReturnType<
  typeof useAviatorLiveRoundStatusSuspenseQuery
>;
export type AviatorLiveRoundStatusQueryResult = Apollo.QueryResult<
  AviatorLiveRoundStatusQuery,
  AviatorLiveRoundStatusQueryVariables
>;
export const PaginatedAviatorPlayerIdsRoundsDocument = gql`
  query paginatedAviatorPlayerIdsRounds(
    $limit: Float
    $page: Float
    $filter: InputFilterPlayerIds
  ) {
    paginatedAviatorPlayerIdsRounds(limit: $limit, page: $page, filter: $filter) {
      docs {
        playerId
        username
      }
    }
  }
`;

/**
 * __usePaginatedAviatorPlayerIdsRoundsQuery__
 *
 * To run a query within a React component, call `usePaginatedAviatorPlayerIdsRoundsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedAviatorPlayerIdsRoundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedAviatorPlayerIdsRoundsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedAviatorPlayerIdsRoundsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaginatedAviatorPlayerIdsRoundsQuery,
    PaginatedAviatorPlayerIdsRoundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaginatedAviatorPlayerIdsRoundsQuery,
    PaginatedAviatorPlayerIdsRoundsQueryVariables
  >(PaginatedAviatorPlayerIdsRoundsDocument, options);
}
export function usePaginatedAviatorPlayerIdsRoundsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedAviatorPlayerIdsRoundsQuery,
    PaginatedAviatorPlayerIdsRoundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaginatedAviatorPlayerIdsRoundsQuery,
    PaginatedAviatorPlayerIdsRoundsQueryVariables
  >(PaginatedAviatorPlayerIdsRoundsDocument, options);
}
export function usePaginatedAviatorPlayerIdsRoundsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedAviatorPlayerIdsRoundsQuery,
    PaginatedAviatorPlayerIdsRoundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PaginatedAviatorPlayerIdsRoundsQuery,
    PaginatedAviatorPlayerIdsRoundsQueryVariables
  >(PaginatedAviatorPlayerIdsRoundsDocument, options);
}
export type PaginatedAviatorPlayerIdsRoundsQueryHookResult = ReturnType<
  typeof usePaginatedAviatorPlayerIdsRoundsQuery
>;
export type PaginatedAviatorPlayerIdsRoundsLazyQueryHookResult = ReturnType<
  typeof usePaginatedAviatorPlayerIdsRoundsLazyQuery
>;
export type PaginatedAviatorPlayerIdsRoundsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedAviatorPlayerIdsRoundsSuspenseQuery
>;
export type PaginatedAviatorPlayerIdsRoundsQueryResult = Apollo.QueryResult<
  PaginatedAviatorPlayerIdsRoundsQuery,
  PaginatedAviatorPlayerIdsRoundsQueryVariables
>;
export const TestProviderDocument = gql`
  mutation testProvider($testProviderInput: TestProvidersInput!) {
    testProvider(testProviderInput: $testProviderInput) {
      data {
        endpoint
        testCase
        errors {
          err
        }
      }
      errorsCount
      message
    }
  }
`;
export type TestProviderMutationFn = Apollo.MutationFunction<
  TestProviderMutation,
  TestProviderMutationVariables
>;

/**
 * __useTestProviderMutation__
 *
 * To run a mutation, you first call `useTestProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testProviderMutation, { data, loading, error }] = useTestProviderMutation({
 *   variables: {
 *      testProviderInput: // value for 'testProviderInput'
 *   },
 * });
 */
export function useTestProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<TestProviderMutation, TestProviderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TestProviderMutation, TestProviderMutationVariables>(
    TestProviderDocument,
    options
  );
}
export type TestProviderMutationHookResult = ReturnType<typeof useTestProviderMutation>;
export type TestProviderMutationResult = Apollo.MutationResult<TestProviderMutation>;
export type TestProviderMutationOptions = Apollo.BaseMutationOptions<
  TestProviderMutation,
  TestProviderMutationVariables
>;
export const PaginatedAviatorRoundTransactionsDocument = gql`
  query paginatedAviatorRoundTransactions(
    $limit: Float!
    $page: Float!
    $filter: InputFilterRoundTransaction!
  ) {
    paginatedAviatorRoundTransactions(limit: $limit, page: $page, filter: $filter) {
      total
      page
      limit
      skip
      docs {
        _id
        providerId
        freebetUsageLogId
        playerId
        roundId
        win
        username
        betAmount
        multiplier
        cashoutDate
        isAutoCashout
        maxMultiplier
        roundHash
        serverHash
        clientHash
        playerRoundBetId
        createdAt
        language
        currency
      }
    }
  }
`;

/**
 * __usePaginatedAviatorRoundTransactionsQuery__
 *
 * To run a query within a React component, call `usePaginatedAviatorRoundTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedAviatorRoundTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedAviatorRoundTransactionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedAviatorRoundTransactionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaginatedAviatorRoundTransactionsQuery,
    PaginatedAviatorRoundTransactionsQueryVariables
  > &
    (
      | { variables: PaginatedAviatorRoundTransactionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaginatedAviatorRoundTransactionsQuery,
    PaginatedAviatorRoundTransactionsQueryVariables
  >(PaginatedAviatorRoundTransactionsDocument, options);
}
export function usePaginatedAviatorRoundTransactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedAviatorRoundTransactionsQuery,
    PaginatedAviatorRoundTransactionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaginatedAviatorRoundTransactionsQuery,
    PaginatedAviatorRoundTransactionsQueryVariables
  >(PaginatedAviatorRoundTransactionsDocument, options);
}
export function usePaginatedAviatorRoundTransactionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedAviatorRoundTransactionsQuery,
    PaginatedAviatorRoundTransactionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PaginatedAviatorRoundTransactionsQuery,
    PaginatedAviatorRoundTransactionsQueryVariables
  >(PaginatedAviatorRoundTransactionsDocument, options);
}
export type PaginatedAviatorRoundTransactionsQueryHookResult = ReturnType<
  typeof usePaginatedAviatorRoundTransactionsQuery
>;
export type PaginatedAviatorRoundTransactionsLazyQueryHookResult = ReturnType<
  typeof usePaginatedAviatorRoundTransactionsLazyQuery
>;
export type PaginatedAviatorRoundTransactionsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedAviatorRoundTransactionsSuspenseQuery
>;
export type PaginatedAviatorRoundTransactionsQueryResult = Apollo.QueryResult<
  PaginatedAviatorRoundTransactionsQuery,
  PaginatedAviatorRoundTransactionsQueryVariables
>;
export const PaginatedProviderTransactionsDocument = gql`
  query paginatedProviderTransactions(
    $limit: Float!
    $page: Float!
    $filter: InputFilterProviderTransaction!
  ) {
    paginatedProviderTransactions(limit: $limit, page: $page, filter: $filter) {
      total
      page
      limit
      skip
      docs {
        _id
        createdAt
        category
        language
        currency
        roundId
        transactionId
        operation
        reason
        providerId
        playerId
        amount
        multiplier
        balance
        gameId
      }
    }
  }
`;

/**
 * __usePaginatedProviderTransactionsQuery__
 *
 * To run a query within a React component, call `usePaginatedProviderTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedProviderTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedProviderTransactionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedProviderTransactionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaginatedProviderTransactionsQuery,
    PaginatedProviderTransactionsQueryVariables
  > &
    ({ variables: PaginatedProviderTransactionsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaginatedProviderTransactionsQuery,
    PaginatedProviderTransactionsQueryVariables
  >(PaginatedProviderTransactionsDocument, options);
}
export function usePaginatedProviderTransactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedProviderTransactionsQuery,
    PaginatedProviderTransactionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaginatedProviderTransactionsQuery,
    PaginatedProviderTransactionsQueryVariables
  >(PaginatedProviderTransactionsDocument, options);
}
export function usePaginatedProviderTransactionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedProviderTransactionsQuery,
    PaginatedProviderTransactionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PaginatedProviderTransactionsQuery,
    PaginatedProviderTransactionsQueryVariables
  >(PaginatedProviderTransactionsDocument, options);
}
export type PaginatedProviderTransactionsQueryHookResult = ReturnType<
  typeof usePaginatedProviderTransactionsQuery
>;
export type PaginatedProviderTransactionsLazyQueryHookResult = ReturnType<
  typeof usePaginatedProviderTransactionsLazyQuery
>;
export type PaginatedProviderTransactionsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedProviderTransactionsSuspenseQuery
>;
export type PaginatedProviderTransactionsQueryResult = Apollo.QueryResult<
  PaginatedProviderTransactionsQuery,
  PaginatedProviderTransactionsQueryVariables
>;
export const PaginatedProviderIgnoredRequestsDocument = gql`
  query paginatedProviderIgnoredRequests(
    $limit: Float!
    $page: Float!
    $filter: InputFilterIgnoredRequests!
  ) {
    paginatedProviderIgnoredRequests(limit: $limit, page: $page, filter: $filter) {
      total
      page
      limit
      skip
      docs {
        createdAt
        reason
        operation
        playerId
        roundId
        betId
        betAmount
        providerId
        startDate
        endDate
      }
    }
  }
`;

/**
 * __usePaginatedProviderIgnoredRequestsQuery__
 *
 * To run a query within a React component, call `usePaginatedProviderIgnoredRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedProviderIgnoredRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedProviderIgnoredRequestsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedProviderIgnoredRequestsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaginatedProviderIgnoredRequestsQuery,
    PaginatedProviderIgnoredRequestsQueryVariables
  > &
    (
      | { variables: PaginatedProviderIgnoredRequestsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaginatedProviderIgnoredRequestsQuery,
    PaginatedProviderIgnoredRequestsQueryVariables
  >(PaginatedProviderIgnoredRequestsDocument, options);
}
export function usePaginatedProviderIgnoredRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedProviderIgnoredRequestsQuery,
    PaginatedProviderIgnoredRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaginatedProviderIgnoredRequestsQuery,
    PaginatedProviderIgnoredRequestsQueryVariables
  >(PaginatedProviderIgnoredRequestsDocument, options);
}
export function usePaginatedProviderIgnoredRequestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedProviderIgnoredRequestsQuery,
    PaginatedProviderIgnoredRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PaginatedProviderIgnoredRequestsQuery,
    PaginatedProviderIgnoredRequestsQueryVariables
  >(PaginatedProviderIgnoredRequestsDocument, options);
}
export type PaginatedProviderIgnoredRequestsQueryHookResult = ReturnType<
  typeof usePaginatedProviderIgnoredRequestsQuery
>;
export type PaginatedProviderIgnoredRequestsLazyQueryHookResult = ReturnType<
  typeof usePaginatedProviderIgnoredRequestsLazyQuery
>;
export type PaginatedProviderIgnoredRequestsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedProviderIgnoredRequestsSuspenseQuery
>;
export type PaginatedProviderIgnoredRequestsQueryResult = Apollo.QueryResult<
  PaginatedProviderIgnoredRequestsQuery,
  PaginatedProviderIgnoredRequestsQueryVariables
>;
export const FailedSendCreditTasksDocument = gql`
  query failedSendCreditTasks {
    aviatorFailedSendCreditTasks {
      id
      attempts
      finishedOn
      processedOn
      failedReason
      data {
        transactionId
        roundId
        providerId
        playerId
        betId
      }
    }
  }
`;

/**
 * __useFailedSendCreditTasksQuery__
 *
 * To run a query within a React component, call `useFailedSendCreditTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFailedSendCreditTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFailedSendCreditTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useFailedSendCreditTasksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FailedSendCreditTasksQuery,
    FailedSendCreditTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<FailedSendCreditTasksQuery, FailedSendCreditTasksQueryVariables>(
    FailedSendCreditTasksDocument,
    options
  );
}
export function useFailedSendCreditTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FailedSendCreditTasksQuery,
    FailedSendCreditTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<FailedSendCreditTasksQuery, FailedSendCreditTasksQueryVariables>(
    FailedSendCreditTasksDocument,
    options
  );
}
export function useFailedSendCreditTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FailedSendCreditTasksQuery,
    FailedSendCreditTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<FailedSendCreditTasksQuery, FailedSendCreditTasksQueryVariables>(
    FailedSendCreditTasksDocument,
    options
  );
}
export type FailedSendCreditTasksQueryHookResult = ReturnType<typeof useFailedSendCreditTasksQuery>;
export type FailedSendCreditTasksLazyQueryHookResult = ReturnType<
  typeof useFailedSendCreditTasksLazyQuery
>;
export type FailedSendCreditTasksSuspenseQueryHookResult = ReturnType<
  typeof useFailedSendCreditTasksSuspenseQuery
>;
export type FailedSendCreditTasksQueryResult = Apollo.QueryResult<
  FailedSendCreditTasksQuery,
  FailedSendCreditTasksQueryVariables
>;
export const FailedSendCreditTransactionsDocument = gql`
  query failedSendCreditTransactions(
    $limit: Float
    $page: Float
    $filter: InputFilterProviderFailedTransactions
  ) {
    aviatorFailedProviderSendCreditTransactions(limit: $limit, page: $page, filter: $filter) {
      total
      page
      limit
      skip
      docs {
        _id
        createdAt
        category
        language
        currency
        roundId
        transactionId
        operation
        reason
        providerId
        playerId
        amount
        multiplier
        gameId
        previousTransactionId
        awardId
        errorMessage
        isResolved
      }
    }
  }
`;

/**
 * __useFailedSendCreditTransactionsQuery__
 *
 * To run a query within a React component, call `useFailedSendCreditTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFailedSendCreditTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFailedSendCreditTransactionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFailedSendCreditTransactionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FailedSendCreditTransactionsQuery,
    FailedSendCreditTransactionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FailedSendCreditTransactionsQuery,
    FailedSendCreditTransactionsQueryVariables
  >(FailedSendCreditTransactionsDocument, options);
}
export function useFailedSendCreditTransactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FailedSendCreditTransactionsQuery,
    FailedSendCreditTransactionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FailedSendCreditTransactionsQuery,
    FailedSendCreditTransactionsQueryVariables
  >(FailedSendCreditTransactionsDocument, options);
}
export function useFailedSendCreditTransactionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FailedSendCreditTransactionsQuery,
    FailedSendCreditTransactionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FailedSendCreditTransactionsQuery,
    FailedSendCreditTransactionsQueryVariables
  >(FailedSendCreditTransactionsDocument, options);
}
export type FailedSendCreditTransactionsQueryHookResult = ReturnType<
  typeof useFailedSendCreditTransactionsQuery
>;
export type FailedSendCreditTransactionsLazyQueryHookResult = ReturnType<
  typeof useFailedSendCreditTransactionsLazyQuery
>;
export type FailedSendCreditTransactionsSuspenseQueryHookResult = ReturnType<
  typeof useFailedSendCreditTransactionsSuspenseQuery
>;
export type FailedSendCreditTransactionsQueryResult = Apollo.QueryResult<
  FailedSendCreditTransactionsQuery,
  FailedSendCreditTransactionsQueryVariables
>;
export const ScheduledSendCreditTasksDocument = gql`
  query scheduledSendCreditTasks {
    aviatorScheduledSendCreditTasks {
      id
      delayMs
      createdAt
      data {
        apiUrl
        transactionId
        roundId
        amount
        language
        currency
        reason
        category
        providerId
        gameId
        operation
        playerId
        multiplier
        betId
      }
    }
  }
`;

/**
 * __useScheduledSendCreditTasksQuery__
 *
 * To run a query within a React component, call `useScheduledSendCreditTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledSendCreditTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledSendCreditTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useScheduledSendCreditTasksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ScheduledSendCreditTasksQuery,
    ScheduledSendCreditTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ScheduledSendCreditTasksQuery, ScheduledSendCreditTasksQueryVariables>(
    ScheduledSendCreditTasksDocument,
    options
  );
}
export function useScheduledSendCreditTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScheduledSendCreditTasksQuery,
    ScheduledSendCreditTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ScheduledSendCreditTasksQuery, ScheduledSendCreditTasksQueryVariables>(
    ScheduledSendCreditTasksDocument,
    options
  );
}
export function useScheduledSendCreditTasksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ScheduledSendCreditTasksQuery,
    ScheduledSendCreditTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ScheduledSendCreditTasksQuery,
    ScheduledSendCreditTasksQueryVariables
  >(ScheduledSendCreditTasksDocument, options);
}
export type ScheduledSendCreditTasksQueryHookResult = ReturnType<
  typeof useScheduledSendCreditTasksQuery
>;
export type ScheduledSendCreditTasksLazyQueryHookResult = ReturnType<
  typeof useScheduledSendCreditTasksLazyQuery
>;
export type ScheduledSendCreditTasksSuspenseQueryHookResult = ReturnType<
  typeof useScheduledSendCreditTasksSuspenseQuery
>;
export type ScheduledSendCreditTasksQueryResult = Apollo.QueryResult<
  ScheduledSendCreditTasksQuery,
  ScheduledSendCreditTasksQueryVariables
>;
export const GetUsersDocument = gql`
  query getUsers {
    users {
      id
      email
      providerId
      roleIds
      isProviderUsersAdmin
      providerRgs {
        rgsId
        providerIds
      }
    }
  }
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export function useGetUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUserDocument = gql`
  query getUser($id: String!) {
    user(id: $id) {
      id
      email
      providerId
      roleIds
      isProviderUsersAdmin
      providerRgs {
        rgsId
        providerIds
      }
      allowedRoleIds
    }
  }
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> &
    ({ variables: GetUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const UpdateUserDocument = gql`
  mutation updateUser($input: InputUpdateUser!) {
    updateUser(input: $input) {
      id
    }
  }
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options
  );
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const DeleteUserDocument = gql`
  mutation deleteUser($userId: String!) {
    deleteUser(userId: $userId)
  }
`;
export type DeleteUserMutationFn = Apollo.MutationFunction<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(
    DeleteUserDocument,
    options
  );
}
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;
export const GetRolesDocument = gql`
  query getRoles {
    roles {
      id
      name
      description
      permissions
      isEditable
    }
  }
`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
}
export function useGetRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
}
export function useGetRolesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
}
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesSuspenseQueryHookResult = ReturnType<typeof useGetRolesSuspenseQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetRoleDocument = gql`
  query getRole($id: String!) {
    role(id: $id) {
      id
      name
      description
      permissions
    }
  }
`;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoleQuery(
  baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables> &
    ({ variables: GetRoleQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
}
export function useGetRoleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
}
export function useGetRoleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
}
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleSuspenseQueryHookResult = ReturnType<typeof useGetRoleSuspenseQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>;
export const GetPermissionsDocument = gql`
  query getPermissions {
    permissions
  }
`;

/**
 * __useGetPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(
    GetPermissionsDocument,
    options
  );
}
export function useGetPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(
    GetPermissionsDocument,
    options
  );
}
export function useGetPermissionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(
    GetPermissionsDocument,
    options
  );
}
export type GetPermissionsQueryHookResult = ReturnType<typeof useGetPermissionsQuery>;
export type GetPermissionsLazyQueryHookResult = ReturnType<typeof useGetPermissionsLazyQuery>;
export type GetPermissionsSuspenseQueryHookResult = ReturnType<
  typeof useGetPermissionsSuspenseQuery
>;
export type GetPermissionsQueryResult = Apollo.QueryResult<
  GetPermissionsQuery,
  GetPermissionsQueryVariables
>;
export const CreateRoleDocument = gql`
  mutation createRole($input: InputCreateRole!) {
    createRole(input: $input) {
      id
    }
  }
`;
export type CreateRoleMutationFn = Apollo.MutationFunction<
  CreateRoleMutation,
  CreateRoleMutationVariables
>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(
    CreateRoleDocument,
    options
  );
}
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<
  CreateRoleMutation,
  CreateRoleMutationVariables
>;
export const CreateUserDocument = gql`
  mutation createUser($input: InputCreateUser!) {
    createUser(input: $input) {
      id
    }
  }
`;
export type CreateUserMutationFn = Apollo.MutationFunction<
  CreateUserMutation,
  CreateUserMutationVariables
>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(
    CreateUserDocument,
    options
  );
}
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export const DeleteRoleDocument = gql`
  mutation deleteRole($input: InputDeleteRole!) {
    deleteRole(input: $input)
  }
`;
export type DeleteRoleMutationFn = Apollo.MutationFunction<
  DeleteRoleMutation,
  DeleteRoleMutationVariables
>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(
    DeleteRoleDocument,
    options
  );
}
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<
  DeleteRoleMutation,
  DeleteRoleMutationVariables
>;
export const GetSessionDocument = gql`
  query getSession {
    session {
      provider {
        id
        name
      }
      session {
        id
        email
        providerIds
        permissions
        isSuper
        rgsIds
        isProviderUsersAdmin
        allowedRoleIds
      }
    }
  }
`;

/**
 * __useGetSessionQuery__
 *
 * To run a query within a React component, call `useGetSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSessionQuery, GetSessionQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
}
export function useGetSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSessionQuery, GetSessionQueryVariables>(
    GetSessionDocument,
    options
  );
}
export function useGetSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSessionQuery, GetSessionQueryVariables>(
    GetSessionDocument,
    options
  );
}
export type GetSessionQueryHookResult = ReturnType<typeof useGetSessionQuery>;
export type GetSessionLazyQueryHookResult = ReturnType<typeof useGetSessionLazyQuery>;
export type GetSessionSuspenseQueryHookResult = ReturnType<typeof useGetSessionSuspenseQuery>;
export type GetSessionQueryResult = Apollo.QueryResult<GetSessionQuery, GetSessionQueryVariables>;
export const SignInDocument = gql`
  mutation signIn($email: String!, $password: String!) {
    signIn(email: $email, password: $password) {
      accessToken
      refreshToken
    }
  }
`;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(
  baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
}
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<
  SignInMutation,
  SignInMutationVariables
>;
export const RefreshTokenDocument = gql`
  mutation refreshToken($token: String!) {
    refreshToken(token: $token) {
      accessToken
      refreshToken
    }
  }
`;
export type RefreshTokenMutationFn = Apollo.MutationFunction<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRefreshTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(
    RefreshTokenDocument,
    options
  );
}
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
>;
export const CreateAviatorPermissionDocument = gql`
  mutation createAviatorPermission($permission: String!) {
    addPermission(permission: $permission)
  }
`;
export type CreateAviatorPermissionMutationFn = Apollo.MutationFunction<
  CreateAviatorPermissionMutation,
  CreateAviatorPermissionMutationVariables
>;

/**
 * __useCreateAviatorPermissionMutation__
 *
 * To run a mutation, you first call `useCreateAviatorPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAviatorPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAviatorPermissionMutation, { data, loading, error }] = useCreateAviatorPermissionMutation({
 *   variables: {
 *      permission: // value for 'permission'
 *   },
 * });
 */
export function useCreateAviatorPermissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAviatorPermissionMutation,
    CreateAviatorPermissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAviatorPermissionMutation,
    CreateAviatorPermissionMutationVariables
  >(CreateAviatorPermissionDocument, options);
}
export type CreateAviatorPermissionMutationHookResult = ReturnType<
  typeof useCreateAviatorPermissionMutation
>;
export type CreateAviatorPermissionMutationResult =
  Apollo.MutationResult<CreateAviatorPermissionMutation>;
export type CreateAviatorPermissionMutationOptions = Apollo.BaseMutationOptions<
  CreateAviatorPermissionMutation,
  CreateAviatorPermissionMutationVariables
>;
export const DeleteSelectedRolePermissionDocument = gql`
  mutation deleteSelectedRolePermission($input: InputRemoveRolePermission!) {
    removeRolePermission(input: $input)
  }
`;
export type DeleteSelectedRolePermissionMutationFn = Apollo.MutationFunction<
  DeleteSelectedRolePermissionMutation,
  DeleteSelectedRolePermissionMutationVariables
>;

/**
 * __useDeleteSelectedRolePermissionMutation__
 *
 * To run a mutation, you first call `useDeleteSelectedRolePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSelectedRolePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSelectedRolePermissionMutation, { data, loading, error }] = useDeleteSelectedRolePermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSelectedRolePermissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSelectedRolePermissionMutation,
    DeleteSelectedRolePermissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSelectedRolePermissionMutation,
    DeleteSelectedRolePermissionMutationVariables
  >(DeleteSelectedRolePermissionDocument, options);
}
export type DeleteSelectedRolePermissionMutationHookResult = ReturnType<
  typeof useDeleteSelectedRolePermissionMutation
>;
export type DeleteSelectedRolePermissionMutationResult =
  Apollo.MutationResult<DeleteSelectedRolePermissionMutation>;
export type DeleteSelectedRolePermissionMutationOptions = Apollo.BaseMutationOptions<
  DeleteSelectedRolePermissionMutation,
  DeleteSelectedRolePermissionMutationVariables
>;
export const AssignRolePermissionsDocument = gql`
  mutation assignRolePermissions($input: InputAssignRolePermissions!) {
    assignRolePermissions(input: $input)
  }
`;
export type AssignRolePermissionsMutationFn = Apollo.MutationFunction<
  AssignRolePermissionsMutation,
  AssignRolePermissionsMutationVariables
>;

/**
 * __useAssignRolePermissionsMutation__
 *
 * To run a mutation, you first call `useAssignRolePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRolePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRolePermissionsMutation, { data, loading, error }] = useAssignRolePermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRolePermissionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignRolePermissionsMutation,
    AssignRolePermissionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignRolePermissionsMutation, AssignRolePermissionsMutationVariables>(
    AssignRolePermissionsDocument,
    options
  );
}
export type AssignRolePermissionsMutationHookResult = ReturnType<
  typeof useAssignRolePermissionsMutation
>;
export type AssignRolePermissionsMutationResult =
  Apollo.MutationResult<AssignRolePermissionsMutation>;
export type AssignRolePermissionsMutationOptions = Apollo.BaseMutationOptions<
  AssignRolePermissionsMutation,
  AssignRolePermissionsMutationVariables
>;
